import { ligainicial } from "./rutainicial.js";

const ligabase = ligainicial + "2020/Lic/C"; 

export const licitaciones2020= [
    {
        // CONVOCATORIA NUM# 026
            'numConvocatoria' : 'Convocatoria No. 026/2020.',
            'idConvocatoria' : 'Convocatoria26',
            'procedimientos' : [
        // Licitación N279
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N279-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 7 al 14 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación asfáltica en calle Robles en la comunidad de La Estancia; ubicada en la localidad de La Estancia, Municipio de Actopan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }26/N279/N279.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }26/N279/JAN279.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }26/N279/APN279.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }26/N279/FAN279.pdf`,
                    },
                    ],
                },
        // Licitación N278
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N278-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 7 al 14 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de pavimento de concreto hidráulico y drenaje sanitario en calle Ilusión; ubicada en la localidad y Municipio de Tlanchinol, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }26/N278/N278.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }26/N278/JAN278.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }26/N278/APN278.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }26/N278/FAN278.pdf`,
                    },
                    {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligabase }26/N278/AMDFAN278.pdf`,
                    },
                    ],
                },
        // Licitación N277
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N277-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 7 al 14 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Rehabilitación de la red de agua potable y pavimentación hidráulica en la calle Guadalupe Victoria, sector Casa Grande, San Agustín Tlaxiaca; ubicada en la localidad de Barrio Casagrande, Municipio de San Agustín Tlaxiaca, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }26/N277/N277.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }26/N277/JAN277.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }26/N277/APN277.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }26/N277/FAN277.pdf`,
                    },
                    ],
                },
        // Licitación N276
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N276-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 7 al 14 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Remodelación de la plaza principal Jagüey de Téllez; ubicada en la localidad de Jagüey de Téllez (Estación Téllez), Municipio de Zempoala, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }26/N276/N276.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }26/N276/JAN276.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }26/N276/APN276.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }26/N276/FAN276.pdf`,
                    },
                    ],
                },
        // Licitación N275
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N275-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 7 al 14 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico en Avenida Revolución; ubicada en la localidad y Municipio de Tlaxcoapan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }26/N275/N275.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }26/N275/JAN275.pdf`,
                    },
                    ],
                },
        // Licitación N274
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N274-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 7 al 14 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de pavimentación hidráulica en calle Rey Moctezuma (La Cima); ubicada en la localidad y Municipio de Epazoyucan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }26/N274/N274.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }26/N274/JAN274.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }26/N274/APN274.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }26/N274/FAN274.pdf`,
                    },
                    ],
                },
        // Licitación N273
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N273-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 7 al 14 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de techado en Jardín de Niños "Campanita"; ubicada en la localidad de El Saucillo, Municipio de Huichapan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }26/N273/N273.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }26/N273/JAN273.pdf`,
                    },
                    ],
                },
        // Licitación N272
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N272-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 7 al 14 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación asfáltica en barrio de San Antonio; ubicada en la localidad y Municipio de Ixmiquilpan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }26/N272/N272.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }26/N272/JAN272.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }26/N272/APN272.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }26/N272/FAN272.pdf`,
                    },
                    ],
                },
        // Licitación N271
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N271-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 7 al 14 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación con concreto hidráulico y drenaje en la localidad de La Unión (La Trinidad y Anexos), municipio de Acatlán Hidalgo; ubicada en la localidad de La Unión, Municipio de Acatlán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }26/N271/N271.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }26/N271/JAN271.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }26/N271/APN271.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }26/N271/FAN271.pdf`,
                    },
                    ],
                },
        // Licitación N270
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N270-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 7 al 14 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de pavimento hidráulico en calle Ignacio López Rayón; ubicada en la localidad de Ignacio López Rayón, Municipio de Ixmiquipan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }26/N270/N270.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }26/N270/JAN270.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }26/N270/APN270.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }26/N270/FAN270.pdf`,
                    },
                    ],
                },
        // Licitación N269
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N269-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 7 al 14 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de pavimento de concreto hidráulico y drenaje sanitario en calle Joaquín Medina Y Agapito Lara; ubicada en la localidad y Municipio de Tlanchinol, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }26/N269/N269.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }26/N269/JAN269.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }26/N269/APN269.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }26/N269/FAN269.pdf`,
                    },
                    ],
                },
        // Licitación N268
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N268-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 7 al 14 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación asfáltica de calle Pirules en la comunidad del Huaxtho; ubicada en la localidad de El Huaxto, Municipio de Actopan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }26/N268/N268.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }26/N268/JAN268.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }26/N268/APN268.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }26/N268/FAN268.pdf`,
                    },
                    ],
                },
        // Licitación N267
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N267-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 7 al 14 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Empedrado con huellas de concreto en camino acceso a Rinconada; ubicada en la localidad de Rinconada, Municipio de Tasquillo, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }26/N267/N267.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }26/N267/JAN267.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }26/N267/APN267.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }26/N267/FAN267.pdf`,
                    },
                    ],
                },
        // Licitación N266
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N266-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 7 al 14 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica de calle en la comunidad de El Barrón; ubicada en la localidad de Barrón, Municipio de Zimapán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }26/N266/N266.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }26/N266/JAN266.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }26/N266/APN266.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }26/N266/FAN266.pdf`,
                    },
                    ],
                },
        // Licitación N265
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N265-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 7 al 14 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de pavimentación hidráulica en calle Villa de Ayala; ubicada en la localidad de Mixquiahuala, Municipio de Mixquiahuala de Juárez, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }26/N265/N265.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }26/N265/JAN265.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }26/N265/APN265.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }26/N265/FAN265.pdf`,
                    },
                    ],
                },
        // Licitación N264
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N264-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 7 al 14 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Reconstrucción de calle de acceso a col. Benito Juárez; ubicada en la localidad de Benito Juárez, Municipio de Villa de Tezontepec, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }26/N264/N264.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }26/N264/JAN264.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }26/N264/APN264.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }26/N264/FAN264.pdf`,
                    },
                    ],
                },
        // Licitación N263
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N263-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 7 al 14 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica en calle Canal Requena; ubicada en la localidad de Presas, Municipio de Tezontepec de Aldama, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }26/N263/N263.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }26/N263/JAN263.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }26/N263/APN263.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }26/N263/FAN263.pdf`,
                    },
                    ],
                },
        // Licitación N262
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N262-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 7 al 14 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica en la comunidad de Zaragoza calle principal; ubicada en la localidad de Zaragoza, Municipio de Tlahuiltepa, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }26/N262/N262.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }26/N262/JAN262.pdf`,
                    },
                    ],
                },
        // Licitación N261
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N261-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 7 al 14 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de pavimentación asfáltica en calle Guadalupe Ángeles; ubicada en la localidad de La Mora, Municipio de Progreso de Obregón, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }26/N261/N261.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }26/N261/JAN261.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }26/N261/APN261.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }26/N261/FAN261.pdf`,
                    },
                    ],
                },
        // Licitación N260
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N260-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 7 al 14 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de estacionamiento en Hospital Cinta Larga de la colonia 1ra demarcación Poniente; ubicada en la localidad de Motobatha, Municipio de Mixquiahuala de Juárez, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }26/N260/N260.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }26/N260/JAN260.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }26/N260/APN260.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }26/N260/FAN260.pdf`,
                    },
                    ],
                },
        // Licitación N259
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N259-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 7 al 14 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Rehabilitación de acceso principal llano a Huixcazdha, 2da etapa; ubicada en la localidad de Llano Largo, Municipio de Huichapan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }26/N259/N259.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }26/N259/JAN259.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }26/N259/APN259.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }26/N259/FAN259.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 025
            'numConvocatoria' : 'Convocatoria No. 025/2020.',
            'idConvocatoria' : 'Convocatoria25',
            'procedimientos' : [
        // Licitación N258
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N258-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 11 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Reconstrucción de pavimento en el Circuito 3 de Mayo; ubicada en la localidad de Colonia 3 de Mayo, Municipio de Mixquiahuala de Juárez, Estado de Hidalgo. (Segundo procedimiento).',
                    'urlAnexos' : `${ ligabase }25/N258/N258.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }25/N258/JAN258.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }25/N258/APN258.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }25/N258/FAN258.pdf`,
                    },
                    ],
                },
        // Licitación N257
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N257-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 11 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de pavimentación de concreto hidráulico en camino Nicolás Flores - Zimapan; ubicada en la localidad y Municipio de Nicolás Flores, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }25/N257/N257.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }25/N257/JAN257.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }25/N257/APN257.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }25/N257/FAN257.pdf`,
                    },
                    ],
                },
        // Licitación N256
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N256-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 11 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación asfáltica de calle Montevideo Pozo Grande - Daxtha.; ubicada en la localidad de El Daxtha, Municipio de Actopan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }25/N256/N256.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }25/N256/JAN256.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }25/N256/APN256.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }25/N256/FAN256.pdf`,
                    },
                    ],
                },
        // Licitación N255
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N255-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 11 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación asfáltica en calle Plata en la col. Fundición Alta; ubicada en la localidad y Municipio de Actopan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }25/N255/N255.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }25/N255/JAN255.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }25/N255/APN255.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }25/N255/FAN255.pdf`,
                    },
                    ],
                },
        // Licitación N254
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N254-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 11 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de pavimento de concreto hidráulico y drenaje pluvial en calle 23 de Marzo; ubicada en la localidad y Municipio de Tlanchinol, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }25/N254/N254.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }25/N254/JAN254.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }25/N254/APN254.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }25/N254/FAN254.pdf`,
                    },
                    ],
                },
        // Licitación N253
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N253-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 11 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de pavimento hidráulico en Valle La Unión San Joaquín, Valle San José Fracc Valles de Pachuca; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }25/N253/N253.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }25/N253/JAN253.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }25/N253/APN253.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }25/N253/FAN253.pdf`,
                    },
                    ],
                },
        // Licitación N252
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N252-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 11 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de pavimento hidráulico en varias calles en la colonia 15 de Septiembre; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }25/N252/N252.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }25/N252/JAN252.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }25/N252/APN252.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }25/N252/FAN252.pdf`,
                    },
                    ],
                },
        // Licitación N251
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N251-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 10 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica calle Francisco Xavier Mina; ubicada en la localidad y Municipio de Tepeapulco, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }25/N251/N251.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }25/N251/JAN251.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }25/N251/APN251.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }25/N251/FAN251.pdf`,
                    },
                    ],
                },
        // Licitación N250
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N250-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 10 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica en calle La Loma; ubicada en la localidad y Municipio de San Bartolo Tutotepec, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }25/N250/N250.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }25/N250/JAN250.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }25/N250/APN250.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }25/N250/FAN250.pdf`,
                    },
                    ],
                },
        // Licitación N249
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N249-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 10 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica de cda. Emiliano Zapata; ubicada en la localidad de Progreso, Municipio de Progreso de Obregón, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }25/N249/N249.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }25/N249/JAN249.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }25/N249/APN249.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }25/N249/FAN249.pdf`,
                    },
                    ],
                },
        // Licitación N248
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N248-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 10 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica en calles 16 de Septiembre y Lirios; ubicada en la localidad de Progreso, Municipio de Progreso de Obregón, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }25/N248/N248.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }25/N248/JAN248.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }25/N248/APN248.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }25/N248/FAN248.pdf`,
                    },
                    ],
                },
        // Licitación N247
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N247-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 10 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de pavimentación asfáltica en calle Guadalupe Victoria; ubicada en la localidad de El Bondho (1ra. Demarcación), Municipio de Progreso de Obregón, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }25/N247/N247.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }25/N247/JAN247.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }25/N247/APN247.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }25/N247/FAN247.pdf`,
                    },
                    ],
                },
        // Licitación N246
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N246-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 10 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de pavimentación asfáltica cerrada Queretaro; ubicada en la localidad de Huitzila, Municipio de Tizayuca, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }25/N246/N246.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }25/N246/JAN246.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }25/N246/APN246.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }25/N246/FAN246.pdf`,
                    },
                    ],
                },
        // Licitación N245
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N245-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 10 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica en calle insurgentes; ubicada en la localidad de Huitel, Municipio de Tezontepec de Aldama, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }25/N245/N245.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }25/N245/JAN245.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }25/N245/APN245.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }25/N245/FAN245.pdf`,
                    },
                    ],
                },
        // Licitación N244
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N244-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 9 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción  de pavimento hidráulico, drenaje sanitario y agua potable en calle Presas; ubicada en la localidad de El Tinaco, Municipio de Tezontepec de Aldama, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }25/N244/N244.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }25/N244/JAN244.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }25/N244/APN244.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }25/N244/FAN244.pdf`,
                    },
                    ],
                },
        // Licitación N243
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N243-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 9 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Rehabilitación de pavimentación asfáltica en calle Reforma; ubicada en la localidad de Mixquiahuala, Municipio de Mixquiahuala de Juárez, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }25/N243/N243.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }25/N243/JAN243.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }25/N243/APN243.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }25/N243/FAN243.pdf`,
                    },
                    ],
                },
        // Licitación N242
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N242-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 9 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación asfáltica calle 20 de Noviembre; ubicada en la localidad de Mixquiahuala, Municipio de Mixquiahuala de Juárez, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }25/N242/N242.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }25/N242/JAN242.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }25/N242/APN242.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }25/N242/FAN242.pdf`,
                    },
                    ],
                },
        // Licitación N241
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N241-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 9 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Rehabilitación de pavimentación asfáltica en Calle Vicente Guerrero; ubicada en la localidad de Mixquiahuala, Municipio de Mixquiahuala de Juárez, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }25/N241/N241.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }25/N241/JAN241.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }25/N241/APN241.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }25/N241/FAN241.pdf`,
                    },
                    ],
                },
        // Licitación N240
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N240-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 9 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación asfáltica de calle sin nombre (manzana El Camino); ubicada en la localidad de El Alberto, Municipio de Ixmiquilpan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }25/N240/N240.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }25/N240/JAN240.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }25/N240/APN240.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }25/N240/FAN240.pdf`,
                    },
                    ],
                },
        // Licitación N239
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N239-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 9 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica de calle 5a. cerrada de Diego Alarcón de Ocaña; ubicada en la localidad de El Oro, Municipio de Ixmiquilpan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }25/N239/N239.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }25/N239/JAN239.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }25/N239/APN239.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }25/N239/FAN239.pdf`,
                    },
                    ],
                },
        // Licitación N238
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N238-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 9 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de guarniciones y banquetas de calle principal; ubicada en la localidad de La Heredad, Municipio de Ixmiquilpan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }25/N238/N238.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }25/N238/JAN238.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }25/N238/APN238.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }25/N238/FAN238.pdf`,
                    },
                    ],
                },
        // Licitación N237
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N237-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 9 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Empedrado ahogado calle Isaac Rivera Corchado; ubicada en la localidad de Sabina Grande, Municipio de Huichapan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }25/N237/N237.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }25/N237/JAN237.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }25/N237/APN237.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }25/N237/FAN237.pdf`,
                    },
                    ],
                },
        // Licitación N236
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N236-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 9 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación  con concreto hidráulico en la localidad de Alcholoya, municipio de Acatlán Hidalgo; ubicada en la localidad de El Salto de Alcholoya, Municipio de Acatlán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }25/N236/N236.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }25/N236/JAN236.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }25/N236/APN236.pdf`,
                    },
                    ],
                },
        // Licitación N235
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N235-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 9 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación con concreto hidráulico en la localidad de San Bartolo La Barranca, municipio de Acatlán Hidalgo; ubicada en la localidad de San Bartolo, Municipio de Acatlán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }25/N235/N235.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }25/N235/JAN235.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }25/N235/APN235.pdf`,
                    },
                    ],
                },
        // Licitación N234
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N234-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 9 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica en calle Santos Degollado esq. con calle Guadalupe Victoria; ubicada en la localidad de Barrio Casagrande, Municipio de San Agustín Tlaxiaca, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }25/N234/N234.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }25/N234/JAN234.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }25/N234/APN234.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }25/N234/FAN234.pdf`,
                    },
                    ],
                },
        // Licitación N233
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N233-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 9 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico calle Los Pinos col. Agustín Olvera; ubicada en la localidad de Colonia Agustín Olvera, Municipio de Acatlán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }25/N233/N233.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }25/N233/JAN233.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }25/N233/APN233.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }25/N233/FAN233.pdf`,
                    },
                    ],
                },
        // Licitación N232
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N232-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 9 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica en calle Cipres, col. Los Pinos, Delegación Xochitlan, Progreso de Obregón, Hgo.; ubicada en la localidad de Xochitlan, Municipio de Progreso de Obregón, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }25/N232/N232.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }25/N232/JAN232.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }25/N232/APN232.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }25/N232/FAN232.pdf`,
                    },
                    ],
                },
        // Licitación N231
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N231-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 9 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de pavimentación asfáltica en calle 12 de Diciembre; ubicada en la localidad de El Moreno, Municipio de Progreso de Obregón, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }25/N231/N231.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }25/N231/JAN231.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }25/N231/APN231.pdf`,
                    },
                    ],
                },
        // Licitación N230
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N230-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 9 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Guarniciones y banquetas de calles principales, Llano Largo; ubicada en la localidad de Llano Largo, Municipio de Huichapan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }25/N230/N230.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }25/N230/JAN230.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }25/N230/APN230.pdf`,
                    },
                    ],
                },
        // Licitación N229
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N229-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 9 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación Hidráulica de calle Circuito Niños Héroes, Manzana El Vixtha (1ra. etapa); ubicada en la localidad de La Loma Julián Villagrán, Municipio de Ixmiquilpan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }25/N229/N229.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }25/N229/JAN229.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }25/N229/APN229.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }25/N229/FAN229.pdf`,
                    },
                    ],
                },
        // Licitación N228
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N228-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 9 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica Av. del Ejido, El Salitre. 1er etapa; ubicada en la Localidad de El Salitre, Municipio de Tlahuelilpan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }25/N228/N228.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }25/N228/JAN228.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }25/N228/APN228.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }25/N228/FAN228.pdf`,
                    },
                    ],
                },
        // Licitación N227
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N227-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 9 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de pavimentación asfáltica en Av. Cuahutémoc; ubicada en la localidad de Tepojaco, Municipio de Tizayuca, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }25/N227/N227.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }25/N227/JAN227.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }25/N227/APN227.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }25/N227/FAN227.pdf`,
                    },
                    ],
                },
        // Licitación N226
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N226-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 9 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de pavimentación asfáltica e hidráulica camino Las Partidas; ubicada en la localidad de Los Olmos, Municipio de Tizayuca, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }25/N226/N226.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }25/N226/JAN226.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }25/N226/APN226.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }25/N226/FAN226.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 024
            'numConvocatoria' : 'Convocatoria No. 024/2020.',
            'idConvocatoria' : 'Convocatoria24',
            'procedimientos' : [
        // Licitación N225
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N225-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 8 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de pavimento asfáltico en calle Jasso; ubicada en la localidad de Col. Nueva Tlaxiaca, Municipio de San Agustín Tlaxiaca, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }24/N225/N225.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }24/N225/JAN225.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }24/N225/APN225.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }24/N225/FAN225.pdf`,
                    },
                    ],
                },
        // Licitación N224
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N224-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 8 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de Sanitarios con Biodigestores, en el municipio de San Felipe Orizatlán; ubicada en varias localidades del Municipio de San Felipe Orizatlán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }24/N224/N224.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }24/N224/JAN224.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }24/N224/APN224.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }24/N224/FAN224.pdf`,
                    },
                    ],
                },
        // Licitación N223
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N223-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 8 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de Sanitarios con Biodigestores, en el municipio de Calnali; ubicada en varias localidades del Municipio de Calnali, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }24/N223/N223.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }24/N223/JAN223.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }24/N223/APN223.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }24/N223/FAN223.pdf`,
                    },
                    ],
                },
        // Licitación N222
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N222-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 8 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Yahualica; ubicada en varias localidades del Municipio de Yahualica, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }24/N222/N222.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }24/N222/JAN222.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }24/N222/APN222.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }24/N222/FAN222.pdf`,
                    },
                    ],
                },
        // Licitación N221
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N221-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 8 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de Sanitarios con Biodigestores, en el municipio de Yahualica; ubicada en varias localidades del Municipio de Yahualica, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }24/N221/N221.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }24/N221/JAN221.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }24/N221/APN221.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }24/N221/FAN221.pdf`,
                    },
                    ],
                },
        // Licitación N220
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N220-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 8 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Xochiatipan; ubicada en varias localidades del Municipio de Xochiatipan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }24/N220/N220.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }24/N220/JAN220.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }24/N220/APN220.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }24/N220/FAN220.pdf`,
                    },
                    ],
                },
        // Licitación N219
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N219-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 8 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de Sanitarios con Biodigestores, en el Municipio de Xochiatipan; ubicada en varias localidades del Municipio de Xochiatipan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }24/N219/N219.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }24/N219/JAN219.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }24/N219/APN219.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }24/N219/FAN219.pdf`,
                    },
                    ],
                },
        // Licitación N218
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N218-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 8 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Tlanchinol; ubicada en varias localidades del Municipio de Tlanchinol, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }24/N218/N218.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }24/N218/JAN218.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }24/N218/APN218.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }24/N218/FAN218.pdf`,
                    },
                    ],
                },
        // Licitación N217
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N217-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 8 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Tianguistengo; ubicada en varias localidades del Municipio de Tianguistengo, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }24/N217/N217.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }24/N217/JAN217.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }24/N217/APN217.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }24/N217/FAN217.pdf`,
                    },
                    ],
                },
        // Licitación N216
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N216-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 8 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de Sanitarios con Biodigestores, en el municipio de Tianguistengo; ubicada en varias localidades del Municipio de Tianguistengo, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }24/N216/N216.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }24/N216/JAN216.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }24/N216/APN216.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }24/N216/FAN216.pdf`,
                    },
                    ],
                },
        // Licitación N215
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N215-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 8 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Tepehuacan de Guerrero; ubicada en varias localidades del Municipio de Tepehuacan de Guerrero, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }24/N215/N215.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }24/N215/JAN215.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }24/N215/APN215.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }24/N215/FAN215.pdf`,
                    },
                    ],
                },
        // Licitación N214
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N214-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 8 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de Sanitarios con Biodigestores, en el municipio de Tepehuacan de Guerrero; ubicada en varias localidades del Municipio de Tepehuacan de Guerrero, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }24/N214/N214.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }24/N214/JAN214.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }24/N214/APN214.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }24/N214/FAN214.pdf`,
                    },
                    ],
                },
        // Licitación N213
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N213-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 8 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Tenango de Doria; ubicada en varias localidades del Municipio de Tenango de Doria, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }24/N213/N213.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }24/N213/JAN213.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }24/N213/APN213.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }24/N213/FAN213.pdf`,
                    },
                    ],
                },
        // Licitación N212
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N212-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 8 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de San Felipe Orizatlán; ubicada en varias localidades del Municipio de San Felipe Orizatlán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }24/N212/N212.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }24/N212/JAN212.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }24/N212/APN212.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }24/N212/FAN212.pdf`,
                    },
                    ],
                },
        // Licitación N211
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N211-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 7 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de Sanitarios con Biodigestores, en el municipio de San Bartolo Tutotepec; ubicada en varias localidades del Municipio de San Bartolo Tutotepec, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }24/N211/N211.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }24/N211/JAN211.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }24/N211/APN211.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }24/N211/FAN211.pdf`,
                    },
                    ],
                },
        // Licitación N210
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N210-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 7 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de San Bartolo Tutotepec; ubicada en varias localidades del Municipio de San Bartolo Tutotepec, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }24/N210/N210.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }24/N210/JAN210.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }24/N210/APN210.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }24/N210/FAN210.pdf`,
                    },
                    ],
                },
        // Licitación N209
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N209-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 7 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de Sanitarios con Biodigestores, en el municipio de Lolotla; ubicada en varias localidades del Municipio de Lolotla, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }24/N209/N209.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }24/N209/JAN209.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }24/N209/APN209.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }24/N209/FAN209.pdf`,
                    },
                    ],
                },
        // Licitación N208
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N208-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 7 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Lolotla; ubicada en varias localidades del Municipio de Lolotla, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }24/N208/N208.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }24/N208/JAN208.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }24/N208/APN208.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }24/N208/FAN208.pdf`,
                    },
                    ],
                },
        // Licitación N207
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N207-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 7 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de Sanitarios con Biodigestores, en el municipio de Huehuetla; ubicada en varias localidades del Municipio de Huehuetla, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }24/N207/N207.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }24/N207/JAN207.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }24/N207/APN207.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }24/N207/FAN207.pdf`,
                    },
                    ],
                },
        // Licitación N206
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N206-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 7 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Huehuetla; ubicada en varias localidades del Municipio de Huehuetla, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }24/N206/N206.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }24/N206/JAN206.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }24/N206/APN206.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }24/N206/FAN206.pdf`,
                    },
                    ],
                },
        // Licitación N205
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N205-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 7 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de Sanitarios con Biodigestores, en el municipio de Huazalingo; ubicada en varias localidades del Municipio de Huazalingo, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }24/N205/N205.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }24/N205/JAN205.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }24/N205/APN205.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }24/N205/FAN205.pdf`,
                    },
                    ],
                },
        // Licitación N204
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N204-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 7 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Huazalingo; ubicada en varias localidades del Municipio de Huazalingo, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }24/N204/N204.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }24/N204/JAN204.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }24/N204/APN204.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }24/N204/FAN204.pdf`,
                    },
                    ],
                },
        // Licitación N203
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N203-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 7 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Huautla; ubicada en varias localidades del Municipio de Huautla, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }24/N203/N203.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }24/N203/JAN203.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }24/N203/APN203.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }24/N203/FAN203.pdf`,
                    },
                    ],
                },
        // Licitación N202
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N202-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 7 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Chapulhuacán; ubicada en varias localidades del Municipio de Chapulhuacán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }24/N202/N202.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }24/N202/JAN202.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }24/N202/APN202.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }24/N202/FAN202.pdf`,
                    },
                    ],
                },
        // Licitación N201
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N201-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 7 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Calnali; ubicada en varias localidades del Municipio de Calnali, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }24/N201/N201.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }24/N201/JAN201.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }24/N201/APN201.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }24/N201/FAN201.pdf`,
                    },
                    ],
                },
        // Licitación N200
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N200-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 7 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Atlapexco; ubicada en varias localidades del Municipio de Atlapexco, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }24/N200/N200.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }24/N200/JAN200.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }24/N200/APN200.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }24/N200/FAN200.pdf`,
                    },
                    ],
                },
        // Licitación N199
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N199-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 7 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Tlahuiltepa; ubicada en varias localidades del Municipio de Tlahuiltepa, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }24/N199/N199.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }24/N199/JAN199.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }24/N199/APN199.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }24/N199/FAN199.pdf`,
                    },
                    ],
                },
        // Licitación N198
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N198-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 7 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de Sanitarios con Biodigestores, en el municipio de Tlahuiltepa; ubicada en varias localidades del Municipio de Tlahuiltepa, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }24/N198/N198.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }24/N198/JAN198.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }24/N198/APN198.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }24/N198/FAN198.pdf`,
                    },
                    ],
                },
        // Licitación N197
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N197-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 7 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de Sanitarios con Biodigestores, en el municipio de Pisaflores; ubicada en varias localidades del Municipio de Pisaflores, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }24/N197/N197.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }24/N197/JAN197.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }24/N197/APN197.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }24/N197/FAN197.pdf`,
                    },
                    ],
                },
        // Licitación N196
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N196-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 7 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Pisaflores; ubicada en varias localidades del Municipio de Pisaflores, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }24/N196/N196.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }24/N196/JAN196.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }24/N196/APN196.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }24/N196/FAN196.pdf`,
                    },
                    ],
                },
        // Licitación N195
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N195-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 7 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de Sanitarios con Biodigestores, en el municipio de Pacula; ubicada en varias localidades del Municipio de Pacula, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }24/N195/N195.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }24/N195/JAN195.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }24/N195/APN195.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }24/N195/FAN195.pdf`,
                    },
                    ],
                },
        // Licitación N194
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N194-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 4 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Pacula; ubicada en varias localidades del Municipio de Pacula, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }24/N194/N194.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }24/N194/JAN194.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }24/N194/APN194.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }24/N194/FAN194.pdf`,
                    },
                    ],
                },
        // Licitación N193
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N193-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 4 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Nicolás Flores; ubicada en varias localidades del Municipio de Nicolás Flores, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }24/N193/N193.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }24/N193/JAN193.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }24/N193/APN193.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }24/N193/FAN193.pdf`,
                    },
                    ],
                },
        // Licitación N192
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N192-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 4 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de Sanitarios con Biodigestores, en el municipio de Mineral del Chico; ubicada en varias localidades del Municipio de Mineral del Chico, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }24/N192/N192.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }24/N192/JAN192.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }24/N192/APN192.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }24/N192/FAN192.pdf`,
                    },
                    ],
                },
        // Licitación N191
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N191-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 4 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Mineral del Chico; ubicada en varias localidades del Municipio de Mineral del Chico, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }24/N191/N191.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }24/N191/JAN191.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }24/N191/APN191.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }24/N191/FAN191.pdf`,
                    },
                    ],
                },
        // Licitación N190
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N190-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 4 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de Sanitarios con Biodigestores, en el municipio de Metztitlán; ubicada en varias localidades del Municipio de Metztitlán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }24/N190/N190.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }24/N190/JAN190.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }24/N190/APN190.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }24/N190/FAN190.pdf`,
                    },
                    ],
                },
        // Licitación N189
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N189-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 4 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Metztitlán; ubicada en varias localidades del Municipio de Metztitlán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }24/N189/N189.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }24/N189/JAN189.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }24/N189/APN189.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }24/N189/FAN189.pdf`,
                    },
                    ],
                },
        // Licitación N188
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N188-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 4 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de Sanitarios con Biodigestores, en el municipio de La Misión; ubicada en varias localidades del Municipio de La Misión, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }24/N188/N188.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }24/N188/JAN188.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }24/N188/APN188.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }24/N188/FAN188.pdf`,
                    },
                    ],
                },
        // Licitación N187
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N187-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 4 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de La Misión; ubicada en varias localidades del Municipio de La Misión, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }24/N187/N187.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }24/N187/JAN187.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }24/N187/APN187.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }24/N187/FAN187.pdf`,
                    },
                    ],
                },
        // Licitación N186
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N186-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 4 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de Sanitarios con Biodigestores, en el municipio de Jacala de Ledezma; ubicada en varias localidades del Municipio de Jacala de Ledezma, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }24/N186/N186.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }24/N186/JAN186.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }24/N186/APN186.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }24/N186/FAN186.pdf`,
                    },
                    ],
                },
        // Licitación N185
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N185-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 4 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Jacala de Ledezma; ubicada en varias localidades del Municipio de Jacala de Ledezma, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }24/N185/N185.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }24/N185/JAN185.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }24/N185/APN185.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }24/N185/FAN185.pdf`,
                    },
                    ],
                },
        // Licitación N184
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N184-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 4 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Huichapan; ubicada en varias localidades del Municipio de Huichapan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }24/N184/N184.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }24/N184/JAN184.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }24/N184/APN184.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }24/N184/FAN184.pdf`,
                    },
                    ],
                },
        // Licitación N183
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N183-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 4 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de Sanitarios con Biodigestores, en el municipio de Chapantongo; ubicada en varias localidades del Municipio de Chapantongo, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }24/N183/N183.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }24/N183/JAN183.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }24/N183/APN183.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }24/N183/FAN183.pdf`,
                    },
                    ],
                },
        // Licitación N182
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N182-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 4 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Chapantongo; ubicada en varias localidades del Municipio de Chapantongo, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }24/N182/N182.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }24/N182/JAN182.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }24/N182/APN182.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }24/N182/FAN182.pdf`,
                    },
                    ],
                },
        // Licitación N181
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N181-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 4 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de Sanitarios con Biodigestores, en el municipio de Agua Blanca de Iturbide; ubicada en varias localidades del Municipio de Agua Blanca de Iturbide, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }24/N181/N181.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }24/N181/JAN181.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }24/N181/APN181.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }24/N181/FAN181.pdf`,
                    },
                    ],
                },
        // Licitación N180
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N180-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 4 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Agua Blanca de Iturbide; ubicada en varias localidades del Municipio de Agua Blanca de Iturbide, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }24/N180/N180.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }24/N180/JAN180.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }24/N180/APN180.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }24/N180/FAN180.pdf`,
                    },
                    ],
                },
        // Licitación N179
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N179-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 4 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de Sanitarios con Biodigestores, en el municipio de Acaxochitlán; ubicada en varias localidades del Municipio de Acaxochitlán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }24/N179/N179.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }24/N179/JAN179.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }24/N179/APN179.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }24/N179/FAN179.pdf`,
                    },
                    ],
                },
        // Licitación N178
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N178-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de noviembre al 4 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Acaxochitlán; ubicada en varias localidades del Municipio de Acaxochitlán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }24/N178/N178.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }24/N178/JAN178.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }24/N178/APN178.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }24/N178/FAN178.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 023
            'numConvocatoria' : 'Convocatoria No. 023/2020.',
            'idConvocatoria' : 'Convocatoria23',
            'procedimientos' : [
        // Licitación N177
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N177-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 23 de noviembre al 2 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica de calle Insurgentes y Jiménez; ubicada en la localidad de Sayula Pueblo (Sayula), Municipio de Tepetitlán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }23/N177/N177.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }23/N177/JAN177.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }23/N177/APN177.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }23/N177/FAN177.pdf`,
                    },
                    ],
                },
        // Licitación N176
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N176-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 23 de noviembre al 2 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica de acceso Santa María Daxtho; ubicada en la localidad de Santa María Daxtho, Municipio de Tepetitlán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }23/N176/N176.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }23/N176/JAN176.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }23/N176/APN176.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }23/N176/FAN176.pdf`,
                    },
                    ],
                },
        // Licitación N175
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N175-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 23 de noviembre al 2 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica Xithi 1era Sección; ubicada en la localidad de Xithi Primera Sección, Municipio de Tepetitlán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }23/N175/N175.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }23/N175/JAN175.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }23/N175/APN175.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }23/N175/FAN175.pdf`,
                    },
                    {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligabase }23/N175/AMDFAN175.pdf`,
                    },
                    ],
                },
        // Licitación N174
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N174-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 23 de noviembre al 2 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica de calle al panteón 1era etapa; ubicada en la localidad de San Pedro Nextlalpan, Municipio de Tepetitlán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }23/N174/N174.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }23/N174/JAN174.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }23/N174/APN174.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }23/N174/FAN174.pdf`,
                    },
                    ],
                },
        // Licitación N173
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N173-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 23 de noviembre al 2 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de pavimentación hidráulica de calle de acceso a Pachiquitla; ubicada en la localidad de Pachiquitla, Municipio de Xochiatipan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }23/N173/N173.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }23/N173/JAN173.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }23/N173/APN173.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }23/N173/FAN173.pdf`,
                    },
                    ],
                },
        // Licitación N172
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N172-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 23 de noviembre al 2 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de pavimentación hidráulica de calle acceso a Zacatlán; ubicada en la localidad de Zacatlán, Municipio de Xochiatipan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }23/N172/N172.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }23/N172/JAN172.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }23/N172/APN172.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }23/N172/FAN172.pdf`,
                    },
                    ],
                },
        // Licitación N171
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N171-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 23 de noviembre al 2 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica calle sin nombre; ubicada en la localidad de Sta. Ma. Catzotipan (Sta. Ma. Tepetzintl), Municipio de Tlanchinol, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }23/N171/N171.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }23/N171/JAN171.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }23/N171/APN171.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }23/N171/FAN171.pdf`,
                    },
                    ],
                },
        // Licitación N170
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N170-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 23 de noviembre al 2 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de empedrado ahogado; ubicada en la localidad de Bothe, Municipio de Tecozautla, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }23/N170/N170.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }23/N170/JAN170.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }23/N170/APN170.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }23/N170/FAN170.pdf`,
                    },
                    ],
                },
        // Licitación N169
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N169-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 23 de noviembre al 2 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica en acceso principal, barrio Las Manzanas; ubicada en la localidad de Sayula Pueblo (Sayula), Municipio de Tepetitlán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }23/N169/N169.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }23/N169/JAN169.pdf`,
                    },
                    ],
                },
        // Licitación N168
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N168-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 23 de noviembre al 2 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica calle Madero y 5 de Febrero; ubicada en la localidad y Municipio de Tepetitlán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }23/N168/N168.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }23/N168/JAN168.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }23/N168/APN168.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }23/N168/FAN168.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 022
            'numConvocatoria' : 'Convocatoria No. 022/2020.',
            'idConvocatoria' : 'Convocatoria22',
            'procedimientos' : [
        // Licitación N167
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N167-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 23 de noviembre al 1 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico, calle: Benito Juárez y Niños Héroes; ubicada en la localidad de Bothi Baji, Municipio de Actopan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }22/N167/N167.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }22/N167/JAN167.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }22/N167/APN167.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }22/N167/FAN167.pdf`,
                    },
                    ],
                },
        // Licitación N166
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N166-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 23 de noviembre al 1 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico en calle de acceso a  la clínica de Santa María Magdalena; ubicada en la localidad de Santa María Magdalena, Municipio de Actopan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }22/N166/N166.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }22/N166/JAN166.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }22/N166/APN166.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }22/N166/FAN166.pdf`,
                    },
                    ],
                },
        // Licitación N165
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N165-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 23 de noviembre al 1 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de pavimento de concreto hidráulico en calle Tulipanes; ubicada en la localidad y Municipio de Tlanchinol, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }22/N165/N165.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }22/N165/JAN165.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }22/N165/APN165.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }22/N165/FAN165.pdf`,
                    },
                    ],
                },
        // Licitación N164
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N164-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 23 de noviembre al 1 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica en calle de acceso a barrio Tlaxcantitla; ubicada en la localidad y Municipio de Xochiatipan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }22/N164/N164.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }22/N164/JAN164.pdf`,
                    },
                    {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligabase }22/N164/AMDJAN164.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }22/N164/APN164.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }22/N164/FAN164.pdf`,
                    },
                    ],
                },
        // Licitación N163
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N163-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 23 de noviembre al 1 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimento concreto hidráulico calle Michoacán, barrio Metepec; ubicada en la localidad de Metepec Primero, Municipio de Acatlán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }22/N163/N163.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }22/N163/JAN163.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }22/N163/APN163.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }22/N163/FAN163.pdf`,
                    },
                    ],
                },
        // Licitación N162
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N162-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 23 de noviembre al 1 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica calle Javier Rojo Gómez; ubicada en la localidad de Bovedas, Municipio de Atotonilco de Tula, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }22/N162/N162.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }22/N162/JAN162.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }22/N162/APN162.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }22/N162/FAN162.pdf`,
                    },
                    ],
                },
        // Licitación N161
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N161-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 23 de noviembre al 1 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de pavimentación de carpeta asfáltica (primera etapa) en calle Centenario y calle Vicente Guerrero; ubicada en la localidad y Municipio de Ixmiquilpan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }22/N161/N161.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }22/N161/JAN161.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }22/N161/APN161.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }22/N161/FAN161.pdf`,
                    },
                    ],
                },
        // Licitación N160
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N160-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 23 de noviembre al 1 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de techado de cancha de usos múltiples en Esc. Preescolar "El Mezquital" CCT 13DJN0188D, ubicada en la localidad de San Pedro Capula, Municipio de Ixmiquilpan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }22/N160/N160.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }22/N160/JAN160.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }22/N160/APN160.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }22/N160/FAN160.pdf`,
                    },
                    ],
                },
        // Licitación N159
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N159-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 23 de noviembre al 1 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación asfáltica de la calle Ignacio Allende; ubicada en la localidad de Motobatha, Municipio de Mixquiahuala de Juárez, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }22/N159/N159.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }22/N159/JAN159.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }22/N159/APN159.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }22/N159/FAN159.pdf`,
                    },
                    ],
                },
        // Licitación N158
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N158-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 23 de noviembre al 1 de diciembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico de la Av. de Ignacio Zaragoza Sur; ubicada en la localidad de Taxhuada, Municipio de Mixquiahuala de Juárez, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }22/N158/N158.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }22/N158/JAN158.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }22/N158/APN158.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }22/N158/FAN158.pdf`,
                    },
                    ],
                },
        // Licitación N157
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N157-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 23 al 30 de noviembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica calle Emiliano Zapata; ubicada en la localidad de Presas, Municipio de Tezontepec de Aldama, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }22/N157/N157.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }22/N157/JAN157.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }22/N157/APN157.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }22/N157/FAN157.pdf`,
                    },
                    ],
                },
        // Licitación N156
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N156-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 23 al 30 de noviembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de pavimentación asfáltica en calle Francisco Villa; ubicada en la localidad de El Rosario, Municipio de Francisco I. Madero, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }22/N156/N156.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }22/N156/JAN156.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }22/N156/APN156.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }22/N156/FAN156.pdf`,
                    },
                    ],
                },
        // Licitación N155
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N155-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 23 al 30 de noviembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica de la calle Niños Héroes; ubicada en la localidad de Mixquiahuala, Municipio de Mixquiahuala de Juárez, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }22/N155/N155.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }22/N155/JAN155.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }22/N155/APN155.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }22/N155/FAN155.pdf`,
                    },
                    ],
                },
        // Licitación N154
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N154-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 23 al 30 de noviembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de pavimentación asfáltica en calle Mariano Matamoros; ubicada en la localidad de El Moreno, Municipio de Progreso de Obregón, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }22/N154/N154.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }22/N154/JAN154.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }22/N154/APN154.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }22/N154/FAN154.pdf`,
                    },
                    ],
                },
        // Licitación N153
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N153-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 23 al 30 de noviembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica calle sin nombre col. La Cruz; ubicada en la localidad de Teltipan de Juárez, Municipio de Tlaxcoapan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }22/N153/N153.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }22/N153/JAN153.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }22/N153/APN153.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }22/N153/FAN153.pdf`,
                    },
                    ],
                },
        // Licitación N152
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N152-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 23 al 30 de noviembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica de la calle Ixmiquilpan, localidad de La Loma López  Rayón; ubicada en la localidad de La Loma, Municipio de Ixmiquilpan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }22/N152/N152.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }22/N152/JAN152.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }22/N152/APN152.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }22/N152/FAN152.pdf`,
                    },
                    ],
                },
        // Licitación N151
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N151-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 23 al 30 de noviembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica de Fraccionamiento Progreso; ubicada en la localidad de Mixquiahuala, Municipio de Mixquiahuala de Juárez, Hidalgo.',
                    'urlAnexos' : `${ ligabase }22/N151/N151.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }22/N151/JAN151.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }22/N151/APN151.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }22/N151/FAN151.pdf`,
                    },
                    ],
                },
        // Licitación N150
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N150-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 23 al 30 de noviembre de 2020.',
                    'descripcionProcedimiento' : 'Remodelación de mercado municipal 2a etapa; ubicada en la localidad de Mixquiahuala, Municipio de Mixquiahuala de Juárez, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }22/N150/N150.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }22/N150/JAN150.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }22/N150/APN150.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }22/N150/FAN150.pdf`,
                    },
                    ],
                },
        // Licitación N149
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N149-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 23 al 30 de noviembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de pavimentación hidráulica calle Camino a los Reyes Tizayuca; ubicada en la localidad y Municipio de Tizayuca, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }22/N149/N149.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }22/N149/JAN149.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }22/N149/APN149.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }22/N149/FAN149.pdf`,
                    },
                    ],
                },
        // Licitación N148
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N148-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 23 al 30 de noviembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de pavimentación asfáltica calle Paseo de Arboledas; ubicada en la localidad de Mio Cid de Tizayuca, Municipio de Tizayuca, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }22/N148/N148.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }22/N148/JAN148.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }22/N148/APN148.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }22/N148/FAN148.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 021
            'numConvocatoria' : 'Convocatoria No. 021/2020.',
            'idConvocatoria' : 'Convocatoria21',
            'procedimientos' : [
        // Licitación N147
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N147-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 16 al 23 de noviembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de sistema de alcantarillado sanitario para beneficiar a la localidad de Tequexquilico (Bo. Centro), en el municipio de San Felipe Orizatlán; ubicada en la localidad de Tequexquilico, Municipio de San Felipe Orizatlán, Estado de Hidalgo. (Segundo procedimiento).',
                    'urlAnexos' : `${ ligabase }21/N147/N147.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }21/N147/JAN147.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }21/N147/APN147.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }21/N147/FAN147.pdf`,
                    },
                    ],
                },
        // Licitación N146
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N146-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 16 al 23 de noviembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de Sanitarios con Biodigestores, en el municipio de Nicolás Flores; ubicada en varias localidades del Municipio de Nicolás Flores, Estado de Hidalgo. (Segundo procedimiento).',
                    'urlAnexos' : `${ ligabase }21/N146/N146.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }21/N146/JAN146.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }21/N146/APN146.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }21/N146/FAN146.pdf`,
                    },
                    ],
                },
        // Licitación N145
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N145-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 16 al 23 de noviembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación asfáltica 1a etapa, La Huapilla; ubicada en la localidad de Huapilla, Municipio de Ixmiquilpan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }21/N145/N145.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }21/N145/JAN145.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }21/N145/APN145.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }21/N145/FAN145.pdf`,
                    },
                    ],
                },
        // Licitación N144
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N144-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 16 al 23 de noviembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de muro de contención de la comunidad del Sabino carretera principal de Las Barrancas, municipio de Acatlán Hidalgo; ubicada en la localidad de El Sabino (La Barranca), Municipio de Acatlán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }21/N144/N144.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }21/N144/JAN144.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }21/N144/APN144.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }21/N144/FAN144.pdf`,
                    },
                    ],
                },
        // Licitación N143
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N143-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 16 al 23 de noviembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de pavimentación hidráulica de calle acceso a Santiago II; ubicada en la localidad de Santiago II, Municipio de Xochiatipan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }21/N143/N143.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }21/N143/JAN143.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }21/N143/APN143.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }21/N143/FAN143.pdf`,
                    },
                    ],
                },
        // Licitación N142
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N142-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 16 al 23 de noviembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de empedrado ahogado; ubicada en la localidad de Bomanxotha, Municipio de Tecozautla, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }21/N142/N142.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }21/N142/JAN142.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }21/N142/APN142.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }21/N142/FAN142.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 020
            'numConvocatoria' : 'Convocatoria No. 020/2020.',
            'idConvocatoria' : 'Convocatoria20',
            'procedimientos' : [
        // Licitación N141
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N141-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 9 al 20 de noviembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción del sistema de agua potable (Zona 1), para beneficiar a la localidad de Tepepa (Santiago Tepepa), en el municipio de Acaxochitlán; ubicada en la localidad de Tepepa (Santiago Tepepa), Municipio de Acaxochitlán, Estado de Hidalgo. (Segundo procedimiento).',
                    'urlAnexos' : `${ ligabase }20/N141/N141.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }20/N141/JAN141.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }20/N141/APN141.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }20/N141/FAN141.pdf`,
                    },
                    ],
                },
        // Licitación N140
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N140-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 9 al 20 de noviembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica de calle Álvaro Obregón; ubicada en la localidad de Huitel, Municipio de Tezontepec de Aldama, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }20/N140/N140.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }20/N140/JAN140.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }20/N140/APN140.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }20/N140/FAN140.pdf`,
                    },
                    ],
                },
        // Licitación N139
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N139-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 9 al 20 de noviembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica en calle Sonora; ubicada en la localidad de Orizabita, Municipio de Ixmiquilpan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }20/N139/N139.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }20/N139/JAN139.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }20/N139/APN139.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }20/N139/FAN139.pdf`,
                    },
                    ],
                },
        // Licitación N138
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N138-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 9 al 20 de noviembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de pavimento hidráulico 15 cms de espesor; ubicada en la localidad de Pilchiatipa, Municipio de Huazalingo, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }20/N138/N138.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }20/N138/JAN138.pdf`,
                    },
                    ],
                },
        // Licitación N137
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N137-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 9 al 20 de noviembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de pavimentación hidráulica en calle principal La Cruz; ubicada en la localidad de Santa Mónica, Municipio de Epazoyucan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }20/N137/N137.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }20/N137/JAN137.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }20/N137/APN137.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }20/N137/FAN137.pdf`,
                    },
                    ],
                },
        // Licitación N136
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N136-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 9 al 20 de noviembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación asfáltica de la calle Francisco Villa; ubicada en la localidad de Taxhuada, Municipio de Mixquiahuala de Juárez, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }20/N136/N136.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }20/N136/JAN136.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }20/N136/APN136.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }20/N136/FAN136.pdf`,
                    },
                    ],
                },
        // Licitación N135
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N135-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 9 al 20 de noviembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica calle sin nombre; ubicada en la localidad de Cuatlimax, Municipio de Tlanchinol, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }20/N135/N135.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }20/N135/JAN135.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }20/N135/APN135.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }20/N135/FAN135.pdf`,
                    },
                    ],
                },
        // Licitación N134
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N134-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 9 al 20 de noviembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación asfáltica de la calle Francisco I. Madero; ubicada en la localidad de Teñhe, Municipio de Mixquiahuala de Juárez, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }20/N134/N134.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }20/N134/JAN134.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }20/N134/APN134.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }20/N134/FAN134.pdf`,
                    },
                    ],
                },
        // Licitación N133
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N133-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 9 al 20 de noviembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de pavimentación hidráulica en calle 5 de Marzo; ubicada en la localidad y Municipio de Tetepango, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }20/N133/N133.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }20/N133/JAN133.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }20/N133/APN133.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }20/N133/FAN133.pdf`,
                    },
                    ],
                },
        // Licitación N132
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N132-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 9 al 20 de noviembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación con concreto hidráulico en la localidad del Huizache y la Paloma, municipio de Acatlán Hidalgo; ubicada en la localidad de El Huizache y La Paloma, Municipio de Acatlán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }20/N132/N132.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }20/N132/JAN132.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }20/N132/APN132.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }20/N132/FAN132.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 019
            'numConvocatoria' : 'Convocatoria No. 019/2020.',
            'idConvocatoria' : 'Convocatoria19',
            'procedimientos' : [
        // Licitación N131
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N131-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 9 al 19 de noviembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica acceso principal a la localidad de Villa Juárez; ubicada en la localidad de Villa Juárez, Municipio de Nicolás Flores, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }19/N131/N131.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }19/N131/JAN131.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }19/N131/APN131.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }19/N131/FAN131.pdf`,
                    },
                    ],
                },
        // Licitación N130
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N130-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 9 al 19 de noviembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica acceso principal a barrio Loma Bonita en la localidad de Las Milpas; ubicada en la localidad de Las Milpas, Municipio de Nicolás Flores, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }19/N130/N130.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }19/N130/JAN130.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }19/N130/APN130.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }19/N130/FAN130.pdf`,
                    },
                    ],
                },
        // Licitación N129
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N129-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 9 al 19 de noviembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación asfáltica de camino de acceso a La Peña; ubicada en la localidad de La Peña, Municipio de Actopan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }19/N129/N129.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }19/N129/JAN129.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }19/N129/APN129.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }19/N129/FAN129.pdf`,
                    },
                    ],
                },
        // Licitación N128
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N128-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 9 al 19 de noviembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica de calle Francisco Villa; ubicada en la localidad de Benito Juárez, Municipio de Villa de Tezontepec, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }19/N128/N128.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }19/N128/JAN128.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }19/N128/APN128.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }19/N128/FAN128.pdf`,
                    },
                    ],
                },
        // Licitación N127
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N127-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 9 al 19 de noviembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de pavimento asfáltico en la calle Felipe Ángeles; ubicada en la localidad de San Antonio Zaragoza, Municipio de San Salvador, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }19/N127/N127.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }19/N127/JAN127.pdf`,
                    },
                    ],
                },
        // Licitación N126
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N126-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 9 al 19 de noviembre de 2020.',
                    'descripcionProcedimiento' : 'Rehabilitación de Acceso Principal Mamithi; ubicada en la localidad de Mamithi, Municipio de Huichapan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }19/N126/N126.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }19/N126/JAN126.pdf`,
                    },
                    ],
                },
        // Licitación N125
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N125-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 9 al 19 de noviembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica de calle El Olivo; ubicada en la localidad de La Loma, Municipio de Ixmiquilpan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }19/N125/N125.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }19/N125/JAN125.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }19/N125/APN125.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }19/N125/FAN125.pdf`,
                    },
                    ],
                },
        // Licitación N124
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N124-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 9 al 19 de noviembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación con concreto hidráulico guarniciones y banquetas en la localidad de la col. 28 de Mayo, municipio de Acatlán Hidalgo; ubicada en la localidad de Colonia 28 de Mayo (Santa Rosa), Municipio de Acatlán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }19/N124/N124.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }19/N124/JAN124.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }19/N124/APN124.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }19/N124/FAN124.pdf`,
                    },
                    ],
                },
        // Licitación N123
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N123-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 9 al 18 de noviembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación con concreto hidráulico en la localidad de La Calera, municipio de Acatlán Hidalgo; ubicada en la localidad de La Calera, Municipio de Acatlán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }19/N123/N123.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }19/N123/JAN123.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }19/N123/APN123.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }19/N123/FAN123.pdf`,
                    },
                    ],
                },
        // Licitación N122
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N122-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 9 al 18 de noviembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica acceso principal a barrio de Cruz de Piedra en la localidad de Nicolás Flores; ubicada en la localidad de Cruz de Piedra, Municipio de Nicolás Flores, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }19/N122/N122.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }19/N122/JAN122.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }19/N122/APN122.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }19/N122/FAN122.pdf`,
                    },
                    {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligabase }19/N122/AMDFAN122.pdf`,
                    },
                    ],
                },
        // Licitación N121
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N121-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 9 al 18 de noviembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica acceso principal a manzana Agua Fría en la localidad de Zoyatal; ubicada en la localidad de Zoyatal, Municipio de Nicolás Flores, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }19/N121/N121.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }19/N121/JAN121.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }19/N121/APN121.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }19/N121/FAN121.pdf`,
                    },
                    ],
                },
        // Licitación N120
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N120-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 9 al 18 de noviembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica acceso a la telesecundaria; ubicada en la localidad de La Laguna, Municipio de Nicolás Flores, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }19/N120/N120.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }19/N120/JAN120.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }19/N120/APN120.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }19/N120/FAN120.pdf`,
                    },
                    ],
                },
        // Licitación N119
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N119-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 9 al 18 de noviembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica, guarniciones y banquetas y cuneta, barrio Los Olguín; ubicada en la localidad y Municipio de Nicolás Flores, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }19/N119/N119.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }19/N119/JAN119.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }19/N119/APN119.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }19/N119/FAN119.pdf`,
                    },
                    ],
                },
        // Licitación N118
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N118-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 9 al 18 de noviembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica, guarniciones y banquetas y muro de contención; ubicada en la localidad y Municipio de Nicolás Flores, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }19/N118/N118.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }19/N118/JAN118.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }19/N118/APN118.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }19/N118/FAN118.pdf`,
                    },
                    ],
                },
        // Licitación N117
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N117-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 9 al 18 de noviembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica calle Plaza Principal (lado canchas); ubicada en la localidad de Panuaya, Municipio de Tezontepec de Aldama, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }19/N117/N117.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }19/N117/JAN117.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }19/N117/APN117.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }19/N117/FAN117.pdf`,
                    },
                    ],
                },
        // Licitación N116
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N116-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 9 al 18 de noviembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de pavimentación asfáltica en calle Ferrocarril; ubicada en la localidad de Santa Ana Batha, Municipio de Chilcuautla, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }19/N116/N116.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }19/N116/JAN116.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }19/N116/APN116.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }19/N116/FAN116.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 018
            'numConvocatoria' : 'Convocatoria No. 018/2020.',
            'idConvocatoria' : 'Convocatoria18',
            'procedimientos' : [
        // Licitación N115
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N115-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 9 de noviembre de 2020.',
                    'descripcionProcedimiento' : 'Colector de aguas pluviales del Boulevard Acopinalco; ubicada en la localidad de Acopinalco (Acopinalco y Tepetates), Municipio de Apan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }18/N115/N115.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }18/N115/JAN115.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }18/N115/APN115.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }18/N115/FAN115.pdf`,
                    },
                    {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligabase }18/N115/AMDFAN115.pdf`,
                    },
                    ],
                },
        // Licitación N114
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N114-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 9 de noviembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación asfáltica en acceso a la comunidad del Epazote; ubicada en la localidad de El Epazote, Municipio de Tasquillo, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }18/N114/N114.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }18/N114/JAN114.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }18/N114/APN114.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }18/N114/FAN114.pdf`,
                    },
                    ],
                },
        // Licitación N113
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N113-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 9 de noviembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica acceso principal a la localidad; ubicada en la localidad de La Unión, Municipio de Nicolás Flores, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }18/N113/N113.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }18/N113/JAN113.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }18/N113/APN113.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }18/N113/FAN113.pdf`,
                    },
                    ],
                },
        // Licitación N112
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N112-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 9 de noviembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de pavimentación hidráulica en calle Venustiano Carranza; ubicada en la localidad de Santa Mónica, Municipio de Epazoyucan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }18/N112/N112.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }18/N112/JAN112.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }18/N112/APN112.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }18/N112/FAN112.pdf`,
                    },
                    ],
                },
        // Licitación N111
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N111-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 9 de noviembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación asfáltica de calle Álamos; ubicada en la localidad de Demacú, Municipio de San Salvador, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }18/N111/N111.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }18/N111/JAN111.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }18/N111/APN111.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }18/N111/FAN111.pdf`,
                    },
                    ],
                },
        // Licitación N110
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N110-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 9 de noviembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de empedrado ahogado; ubicada en la localidad de Pañhe, Municipio de Tecozautla, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }18/N110/N110.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }18/N110/JAN110.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }18/N110/APN110.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }18/N110/FAN110.pdf`,
                    },
                    ],
                },
        // Licitación N109
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N109-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 9 de noviembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica en la calle Azalea en la colonia Luis Flores; ubicada en la localidad y Municipio de Atlapexco, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }18/N109/N109.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }18/N109/JAN109.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }18/N109/APN109.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }18/N109/FAN109.pdf`,
                    },
                    ],
                },
        // Licitación N108
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N108-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 9 de noviembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica en calle Las Flores y Los pinos en la colonia Humberta Hernández Tovar; ubicada en la localidad y Muncipio de Atlapexco, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }18/N108/N108.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }18/N108/JAN108.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }18/N108/APN108.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }18/N108/FAN108.pdf`,
                    },
                    ],
                },
        // Licitación N107
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N107-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 9 de noviembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica estampada calle acceso al Hiloche; ubicada en la localidad de Barrio El Hiloche, Municipio de Mineral del Monte, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }18/N107/N107.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }18/N107/JAN107.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }18/N107/APN107.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }18/N107/FAN107.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 017
            'numConvocatoria' : 'Convocatoria No. 017/2020.',
            'idConvocatoria' : 'Convocatoria17',
            'procedimientos' : [
        // Licitación N106
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N106-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 26 de octubre al 5 de noviembre de 2020.',
                    'descripcionProcedimiento' : 'Elaboración del estudio y proyecto para la optimización y mejoramiento de la ingeniería vial y estructural del Distribuidor Vial Atirantado; ubicado en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }17/N106/N106.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }17/N106/JAN106.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }17/N106/APN106.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }17/N106/FAN106.pdf`,
                    },
                    ],
                },
        // Licitación N105
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N105-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 26 de octubre al 5 de noviembre de 2020.',
                    'descripcionProcedimiento' : 'Colocación de Impermeabilizante en Azotea del Hospital del Niño DIF Hidalgo; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }17/N105/N105.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }17/N105/JAN105.pdf`,
                    },
                    {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligabase }17/N105/AMDJAN105.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }17/N105/APN105.pdf`,
                    },
                    {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligabase }17/N105/AMDAPN105.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }17/N105/FAN105.pdf`,
                    },
                    ],
                },
        // Licitación N104
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N104-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 26 de octubre al 5 de noviembre de 2020.',
                    'descripcionProcedimiento' : 'Reconstrucción de pavimento en el Circuito 3 de Mayo; ubicada en la localidad de Colonia 3 de Mayo, Municipio de Mixquiahuala de Juárez, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }17/N104/N104.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }17/N104/JAN104.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }17/N104/APN104.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }17/N104/FAN104.pdf`,
                    },
                    ],
                },
        // Licitación N103
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N103-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 26 de octubre al 5 de noviembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica de calle 12 de Julio; ubicada en la localidad de San Pedro Nopancalco, Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }17/N103/N103.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }17/N103/JAN103.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }17/N103/APN103.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }17/N103/FAN103.pdf`,
                    },
                    ],
                },
        // Licitación N102
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N102-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 26 de octubre al 5 de noviembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica de calle 1er. cerrada 21 de Marzo; ubicada en la localidad de San Pedro Nopancalco, Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }17/N102/N102.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }17/N102/JAN102.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }17/N102/APN102.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }17/N102/FAN102.pdf`,
                    },
                    ],
                },
        // Licitación N101
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N101-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 26 de octubre al 5 de noviembre de 2020.',
                    'descripcionProcedimiento' : 'Drenaje, agua y pavimentación hidráulica de calle Geranio; ubicada en la localidad de Santa Gertrudis, Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }17/N101/N101.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }17/N101/JAN101.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }17/N101/APN101.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }17/N101/FAN101.pdf`,
                    },
                    ],
                },
        // Licitación N100
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N100-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 26 de octubre al 5 de noviembre de 2020.',
                    'descripcionProcedimiento' : 'Drenaje y pavimentación hidráulica de calle 13 de Octubre; ubicada en la localidad de San Pedro Nopancalco, Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }17/N100/N100.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }17/N100/JAN100.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }17/N100/APN100.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }17/N100/FAN100.pdf`,
                    },
                    ],
                },
        // Licitación N99
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N99-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 26 de octubre al 5 de noviembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica de calle Emiliano Zapata; ubicada en la localidad de Tepeitic, Municipio de Mixquiahuala de Juárez, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }17/N99/N99.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }17/N99/JAN99.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }17/N99/APN99.pdf`,
                    },
                    ],
                },
        // Licitación N98
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N98-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 26 de octubre al 5 de noviembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica de calle Orus esquina con 12 de Diciembre; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }17/N98/N98.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }17/N98/JAN98.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }17/N98/APN98.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }17/N98/FAN98.pdf`,
                    },
                    ],
                },
        // Licitación N97
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N97-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 26 de octubre al 4 de noviembre de 2020.',
                    'descripcionProcedimiento' : 'Drenaje y pavimentación hidráulica de calle La Ceiba y Palo Escrito; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }17/N97/N97.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }17/N97/JAN97.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }17/N97/APN97.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }17/N97/FAN97.pdf`,
                    },
                    ],
                },
        // Licitación N96
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N96-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 26 de octubre al 4 de noviembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica Cruz de los Negros - Cueva Blanca; ubicada en la localidad de Carboneras, Municipio de Mineral del Chico, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }17/N96/N96.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }17/N96/JAN96.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }17/N96/APN96.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }17/N96/FAN96.pdf`,
                    },
                    ],
                },
        // Licitación N95
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N95-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 26 de octubre al 4 de noviembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación asfáltica de la calle Francisco I. Madero; ubicada en la localidad de Tepeitic, Municipio de Mixquiahuala de Juárez, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }17/N95/N95.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }17/N95/JAN95.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }17/N95/APN95.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }17/N95/FAN95.pdf`,
                    },
                    ],
                },
        // Licitación N94
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N94-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 26 de octubre al 4 de noviembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación asfáltica calle Sonora; ubicada en la localidad de Colonia Morelos, Municipio de Mixquiahuala de Juárez, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }17/N94/N94.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }17/N94/JAN94.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }17/N94/APN94.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }17/N94/FAN94.pdf`,
                    },
                    ],
                },
        // Licitación N93
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N93-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 26 de octubre al 4 de noviembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación asfáltica de 2da etapa Ignacio Zaragoza; ubicada en la localidad de Benito Juárez, Municipio de Mixquiahuala de Juárez, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }17/N93/N93.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }17/N93/JAN93.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }17/N93/APN93.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }17/N93/FAN93.pdf`,
                    },
                    {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligabase }17/N93/AMDFAN93.pdf`,
                    },
                    ],
                },
        // Licitación N92
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N92-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 26 de octubre al 4 de noviembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación asfáltica de acceso al Durazno; ubicada en la localidad de Jagüey Blanco, Municipio de Mixquiahuala de Juárez, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }17/N92/N92.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }17/N92/JAN92.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }17/N92/APN92.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }17/N92/FAN92.pdf`,
                    },
                    ],
                },
        // Licitación N91
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N91-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 26 de octubre al 4 de noviembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación asfáltica de 2da etapa acceso a Hacienda Vieja; ubicada en la localidad de Benito Juárez; ubicada en la localidad de Benito Juárez, Municipio de Mixquiahuala de Juárez, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }17/N91/N91.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }17/N91/JAN91.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }17/N91/APN91.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }17/N91/FAN91.pdf`,
                    },
                    {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligabase }17/N91/AMDFAN91.pdf`,
                    },
                    ],
                },
        // Licitación N90
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N90-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 26 de octubre al 4 de noviembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación asfáltica de Benito Juárez-Hacienda Vieja; ubicada en la localidad de Benito Juárez; ubicada en la localidad de Benito Juárez, Municipio de Mixquiahuala de Juárez, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }17/N90/N90.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }17/N90/JAN90.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }17/N90/APN90.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }17/N90/FAN90.pdf`,
                    },
                    {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligabase }17/N90/AMDFAN90.pdf`,
                    },
                    ],
                },
        // Licitación N89
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N89-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 26 de octubre al 4 de noviembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de pavimentación hidráulica de calle acceso a Cocotla; ubicada en la localidad de Cocotla, Municipio de Xochiatipan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }17/N89/N89.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }17/N89/JAN89.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }17/N89/APN89.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }17/N89/FAN89.pdf`,
                    },
                    {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligabase }17/N89/FAN89.pdf`,
                    },
                    ],
                },
        // Licitación N88
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N88-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 26 de octubre al 4 de noviembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de pavimentación hidráulica en calle Adolfo López Mateos; ubicada en la localidad de Santa Mónica, Municipio de Epazoyucan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }17/N88/N88.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }17/N88/JAN88.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }17/N88/APN88.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }17/N88/FAN88.pdf`,
                    },
                    ],
                },
        // Licitación N87
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N87-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 26 de octubre al 3 de noviembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de pavimentación hidráulica en calle Hidalgo 2; ubicada en la localidad de San Juan Tizahuapan, Municipio de Epazoyucan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }17/N87/N87.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }17/N87/JAN87.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }17/N87/APN87.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }17/N87/FAN87.pdf`,
                    },
                    ],
                },
        // Licitación N86
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N86-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 26 de octubre al 3 de noviembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica en calle camino a Escobillas; ubicada en la localidad de Escobillas, Municipio de Epazoyucan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }17/N86/N86.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }17/N86/JAN86.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }17/N86/APN86.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }17/N86/FAN86.pdf`,
                    },
                    ],
                },
        // Licitación N85
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N85-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 26 de octubre al 3 de noviembre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de muro y pavimentación en calle Rey Moctezuma; ubicada en la localidad y Municipio de Epazoyucan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }17/N85/N85.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }17/N85/JAN85.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }17/N85/APN85.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }17/N85/FAN85.pdf`,
                    },
                    ],
                },
        // Licitación N84
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N84-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 26 de octubre al 3 de noviembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica en calle San Miguel Nopalapa; ubicada en la localidad de San Miguel Nopalapa (Nopalapa), Municipio de Epazoyucan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }17/N84/N84.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }17/N84/JAN84.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }17/N84/APN84.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }17/N84/FAN84.pdf`,
                    },
                    ],
                },
        // Licitación N83
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N83-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 26 de octubre al 3 de noviembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica en calle Chabacano; ubicada en la localidad de Xolostitla de Morelos (Xolostitla), Municipio de Epazoyucan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }17/N83/N83.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }17/N83/JAN83.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }17/N83/APN83.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }17/N83/FAN83.pdf`,
                    },
                    ],
                },
        // Licitación N82
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N82-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 26 de octubre al 3 de noviembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica en calle Limón; ubicada en la localidad de El Ocote Chico, Municipio de Epazoyucan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }17/N82/N82.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }17/N82/JAN82.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }17/N82/APN82.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }17/N82/FAN82.pdf`,
                    },
                    ],
                },
        // Licitación N81
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N81-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 26 de octubre al 3 de noviembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica en camino a Cienega Larga; ubicada en la localidad de El Guajolote, Municipio de Epazoyucan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }17/N81/N81.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }17/N81/JAN81.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }17/N81/APN81.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }17/N81/FAN81.pdf`,
                    },
                    ],
                },
        // Licitación N80
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N80-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 26 de octubre al 3 de noviembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica calle 02 de Abril; ubicada en la localidad y Municipio de Epazoyucan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }17/N80/N80.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }17/N80/JAN80.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }17/N80/APN80.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }17/N80/FAN80.pdf`,
                    },
                    ],
                },
        // Licitación N79
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N79-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 26 de octubre al 3 de noviembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica en calle Hidalgo (Poniente); ubicada en la localidad de San Juan Tizahuapan, Municipio de Epazoyucan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }17/N79/N79.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }17/N79/JAN79.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }17/N79/APN79.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }17/N79/FAN79.pdf`,
                    },
                    ],
                },
        // Licitación N78
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N78-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 26 de octubre al 3 de noviembre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica camino a La Joya; ubicada en la localidad de El Nopalillo, Municipio de Epazoyucan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }17/N78/N78.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }17/N78/JAN78.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }17/N78/APN78.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }17/N78/FAN78.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 016
            'numConvocatoria' : 'Convocatoria No. 016/2020.',
            'idConvocatoria' : 'Convocatoria16',
            'procedimientos' : [
        // Licitación N77
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N77-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 12 al 21 de octubre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de sistema de alcantarillado sanitario (1ª etapa), para beneficiar a la localidad de Mangocuatitla, en el municipio de Yahualica; ubicada en la localidad de Mangocuatitla, Municipio de Yahualica, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }16/N77/N77.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }16/N77/JAN77.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }16/N77/APN77.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }16/N77/FAN77.pdf`,
                    },
                    ],
                },
        // Licitación N76
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N76-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 12 al 21 de octubre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de sistema de alcantarillado sanitario para beneficiar a la localidad de Tequexquilico (Bo. Centro), en el municipio de San Felipe Orizatlán; ubicada en la localidad de Tequexquilico, Municipio de San Felipe Orizatlán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }16/N76/N76.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }16/N76/JAN76.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }16/N76/APN76.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }16/N76/FAN76.pdf`,
                    },
                    ],
                },
        // Licitación N75
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N75-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 12 al 21 de octubre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de sistema de alcantarillado sanitario (1a etapa), para beneficiar a la localidad de San Jerónimo, en el municipio de San Bartolo Tutotepec; ubicada en la localidad de San Jerónimo, Municipio de San Bartolo Tutotepec, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }16/N75/N75.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }16/N75/JAN75.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }16/N75/APN75.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }16/N75/FAN75.pdf`,
                    },
                    ],
                },
        // Licitación N74
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N74-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 12 al 21 de octubre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de Sanitarios con Biodigestores, en el municipio de Xochiatipan; ubicada en varias localidades del Municipio de Xochiatipan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }16/N74/N74.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }16/N74/JAN74.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }16/N74/APN74.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }16/N74/FAN74.pdf`,
                    },
                    ],
                },
        // Licitación N73
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N73-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 12 al 21 de octubre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de Sanitarios con Biodigestores, en el municipio de Huazalingo; ubicada en la localidad de Ahuatitla, Municipio de Huazalingo, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }16/N73/N73.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }16/N73/JAN73.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }16/N73/APN73.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }16/N73/FAN73.pdf`,
                    },
                    ],
                },
        // Licitación N72
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N72-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 12 al 21 de octubre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de Sanitarios con Biodigestores, en el municipio de Tepehuacán de Guerrero; ubicada en la localidad de La Reforma, Municipio de Tepehuacán de Guerrero, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }16/N72/N72.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }16/N72/JAN72.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }16/N72/APN72.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }16/N72/FAN72.pdf`,
                    },
                    ],
                },
        // Licitación N71
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N71-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 12 al 21 de octubre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de Sanitarios con Biodigestores, en el municipio de Yahualica; ubicada en varias localidades del Municipio de Yahualica, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }16/N71/N71.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }16/N71/JAN71.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }16/N71/APN71.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }16/N71/FAN71.pdf`,
                    },
                    ],
                },
        // Licitación N70
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N70-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 12 al 21 de octubre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de Sanitarios con Biodigestores, en el municipio de San Bartolo Tutotepec; ubicada en varias localidades del Municipio de San Bartolo Tutotepec, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }16/N70/N70.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }16/N70/JAN70.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }16/N70/APN70.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }16/N70/FAN70.pdf`,
                    },
                    ],
                },
        // Licitación N69
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N69-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 12 al 20 de octubre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de Sanitarios con Biodigestores, en el municipio de Calnali; ubicada en varias localidades del Municipio de Calnali, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }16/N69/N69.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }16/N69/JAN69.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }16/N69/APN69.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }16/N69/FAN69.pdf`,
                    },
                    ],
                },
        // Licitación N68
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N68-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 12 al 20 de octubre  de 2020.',
                    'descripcionProcedimiento' : 'Construcción de Sanitarios con Biodigestores, en el municipio de Chapulhuacán; ubicada en varias localidades del Municipio de Chapulhuacán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }16/N68/N68.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }16/N68/JAN68.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }16/N68/APN68.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }16/N68/FAN68.pdf`,
                    },
                    ],
                },
        // Licitación N67
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N67-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 12 al 20 de octubre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de Sanitarios con Biodigestores, en el municipio de Tenango de Doria; ubicada en varias localidades del Municipio de Tenango de Doria, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }16/N67/N67.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }16/N67/JAN67.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }16/N67/APN67.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }16/N67/FAN67.pdf`,
                    },
                    ],
                },
        // Licitación N66
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N66-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 12 al 20 de octubre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de Sanitarios con Biodigestores, en el municipio de San Felipe Orizatlán; ubicada en la localidad de Buenos Aires, Municipio de San Felipe Orizatlán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }16/N66/N66.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }16/N66/JAN66.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }16/N66/APN66.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }16/N66/FAN66.pdf`,
                    },
                    ],
                },
        // Licitación N65
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N65-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 12 al 20 de octubre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de Sanitarios con Biodigestores, en el municipio de Huehuetla; ubicada en la localidad de Hermanos Galeana, Municipio de Huehuetla, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }16/N65/N65.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }16/N65/JAN65.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }16/N65/APN65.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }16/N65/FAN65.pdf`,
                    },
                    ],
                },
        // Licitación N64
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N64-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 12 al 20 de octubre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Tianguistengo; ubicada en varias localidades del Municipio de Tianguistengo, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }16/N64/N64.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }16/N64/JAN64.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }16/N64/APN64.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }16/N64/FAN64.pdf`,
                    },
                    ],
                },
        // Licitación N63
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N63-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 12 al 20 de octubre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Huejutla de Reyes; ubicada en varias localidades del Municipio de Huejutla de Reyes, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }16/N63/N63.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }16/N63/JAN63.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }16/N63/APN63.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }16/N63/FAN63.pdf`,
                    },
                    ],
                },
        // Licitación N62
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N62-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 12 al 20 de octubre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Huautla; ubicada en la localidad de Lindero, Municipio de Huautla, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }16/N62/N62.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }16/N62/JAN62.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }16/N62/APN62.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }16/N62/FAN62.pdf`,
                    },
                    ],
                },
        // Licitación N61
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N61-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 12 al 20 de octubre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Huazalingo; ubicada en la localidad de Congreso, Municipio de Huazalingo, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }16/N61/N61.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }16/N61/JAN61.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }16/N61/APN61.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }16/N61/FAN61.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 015
            'numConvocatoria' : 'Convocatoria No. 015/2020.',
            'idConvocatoria' : 'Convocatoria15',
            'procedimientos' : [
        // Licitación N60
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N60-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 12 al 19 de octubre de 2020.',
                    'descripcionProcedimiento' : 'Actualización de estudios y proyectos estratégicos para las zonas metropolitanas de Pachuca y Tulancingo; de Cobertura Estatal.',
                    'urlAnexos' : `${ ligabase }15/N60/N60.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }15/N60/JAN60.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }15/N60/APN60.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }15/N60/FAN60.pdf`,
                    },
                    ],
                },
        // Licitación N59
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N59-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 12 al 19 de octubre de 2020.',
                    'descripcionProcedimiento' : 'Cuartel La Paz, ubicado en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }15/N59/N59.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }15/N59/JAN59.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }15/N59/APN59.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }15/N59/FAN59.pdf`,
                    },
                    ],
                },
        // Licitación N58
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N58-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 12 al 19 de octubre de 2020.',
                    'descripcionProcedimiento' : 'Módulo de medidas especiales, ubicado en la localidad de Campo de Tiro, Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }15/N58/N58.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }15/N58/JAN58.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }15/N58/APN58.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }15/N58/FAN58.pdf`,
                    },
                    ],
                },
        // Licitación N57
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N57-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 12 al 19 de octubre de 2020.',
                    'descripcionProcedimiento' : 'Construcción del sistema de agua potable (Zona 1), para beneficiar a la localidad de Tepepa (Santiago Tepepa), en el municipio de Acaxochitlán; ubicada en la localidad de Tepepa (Santiago Tepepa), Municipio de Acaxochitlán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }15/N57/N57.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }15/N57/JAN57.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }15/N57/APN57.pdf`,
                    },
                    {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligabase }15/N57/AMDAPN57.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }15/N57/FAN57.pdf`,
                    },
                    ],
                },
        // Licitación N56
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N56-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 12 al 19 de octubre de 2020.',
                    'descripcionProcedimiento' : 'Construcción del sistema de agua potable en la localidad de El Deca, en el municipio de Cardonal; ubicada en la localidad de El Deca, Municipio de Cardonal, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }15/N56/N56.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }15/N56/JAN56.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }15/N56/APN56.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }15/N56/FAN56.pdf`,
                    },
                    ],
                },
        // Licitación N55
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N55-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 12 al 19 de octubre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de Sanitarios con Biodigestores, en el municipio de Pacula; ubicada en varias localidades del Municipio de Pacula, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }15/N55/N55.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }15/N55/JAN55.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }15/N55/APN55.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }15/N55/FAN55.pdf`,
                    },
                    ],
                },
        // Licitación N54
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N54-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 12 al 19 de octubre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de Sanitarios con Biodigestores, en el municipio de Agua Blanca de Iturbide; ubicada en varias localidades del Municipio de Agua Blanca de Iturbide, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }15/N54/N54.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }15/N54/JAN54.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }15/N54/APN54.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }15/N54/FAN54.pdf`,
                    },
                    ],
                },
        // Licitación N53
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N53-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 12 al 19 de octubre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de Sanitarios con Biodigestores, en el municipio de Nicolás Flores; ubicada en varias localidades del Municipio de Nicolás Flores, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }15/N53/N53.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }15/N53/JAN53.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }15/N53/APN53.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }15/N53/FAN53.pdf`,
                    },
                    ],
                },
        // Licitación N52
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N52-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 12 al 19 de octubre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de Sanitarios con Biodigestores, en el municipio de Acaxochitlán; ubicada en varias localidades del Municipio de Acaxochitlán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }15/N52/N52.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }15/N52/JAN52.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }15/N52/APN52.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }15/N52/FAN52.pdf`,
                    },
                    ],
                },
        // Licitación N51
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N51-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 12 al 16 de octubre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de Sanitarios con Biodigestores, en el municipio de Pisaflores; ubicada en varias localidades del Municipio de Pisaflores, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }15/N51/N51.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }15/N51/JAN51.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }15/N51/APN51.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }15/N51/FAN51.pdf`,
                    },
                    ],
                },
        // Licitación N50
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N50-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 12 al 16 de octubre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de Sanitarios con Biodigestores, en el municipio de Tlahuiltepa; ubicada en la localidad de Cerro del Águila, Municipio de Tlahuiltepa, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }15/N50/N50.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }15/N50/JAN50.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }15/N50/APN50.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }15/N50/FAN50.pdf`,
                    },
                    ],
                },
        // Licitación N49
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N49-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 12 al 16 de octubre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Ixmiquilpan; ubicada en varias localidades del Municipio de Ixmiquilpan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }15/N49/N49.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }15/N49/JAN49.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }15/N49/APN49.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }15/N49/FAN49.pdf`,
                    },
                    ],
                },
        // Licitación N48
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N48-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 12 al 16 de octubre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Cardonal; ubicada en varias localidades del Municipio de Cardonal, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }15/N48/N48.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }15/N48/JAN48.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }15/N48/APN48.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }15/N48/FAN48.pdf`,
                    },
                    ],
                },
        // Licitación N47
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N47-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 12 al 16 de octubre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Zimapán; ubicada en varias localidades del Municipio de Zimapán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }15/N47/N47.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }15/N47/JAN47.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }15/N47/APN47.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }15/N47/FAN47.pdf`,
                    },
                    ],
                },
        // Licitación N46
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N46-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 12 al 16 de octubre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio en el municipio de Tasquillo; ubicada en varias localidades del Municipio de Tasquillo, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }15/N46/N46.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }15/N46/JAN46.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }15/N46/APN46.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }15/N46/FAN46.pdf`,
                    },
                    ],
                },
        // Licitación N45
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N45-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 12 al 16 de octubre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Nicolás Flores; ubicada en varias localidades del Municipio de Nicolás Flores, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }15/N45/N45.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }15/N45/JAN45.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }15/N45/APN45.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }15/N45/FAN45.pdf`,
                    },
                    ],
                },
        // Licitación N44
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N44-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 12 al 16 de octubre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Tepeji del Río de Ocampo; ubicada en la localidad de San Ildefonso, Municipio de Tepeji del Río de Ocampo, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }15/N44/N44.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }15/N44/JAN44.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }15/N44/APN44.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }15/N44/FAN44.pdf`,
                    },
                    ],
                },
        // Licitación N43
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N43-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 12 al 16 de octubre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de Cuartos Dormitorio, en el municipio de Santiago de Anaya; ubicada en la localidad de Yolotepec, Municipio de Santiago de Anaya, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }15/N43/N43.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }15/N43/JAN43.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }15/N43/APN43.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }15/N43/FAN43.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 014
            'numConvocatoria' : 'Convocatoria No. 014/2020.',
            'idConvocatoria' : 'Convocatoria14',
            'procedimientos' : [
        // Licitación N42
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N42-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 28 de septiembre al 5 de octubre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación asfáltica en Avenida Venustiano Carranza del Km. 0+000 al Km. 1+600, subtramos a pavimentar del Km. 0+000 al Km 0+500 y del Km 0+900 al Km 1+600; ubicada en la localidad de Cañada, Municipio de Atotonilco de Tula, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }14/N42/N42.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }14/N42/JAN42.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }14/N42/APN42.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }14/N42/FAN42.pdf`,
                    },
                    ],
                },
        // Licitación N41
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N41-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 28 de septiembre al 5 de octubre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de pavimento de concreto hidráulico en camino principal Tepepa - Ojo de Agua Las Palomas; ubicada en la localidad de Tepepa (Santiago Tepepa), Municipio de Acaxochitlán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }14/N41/N41.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }14/N41/JAN41.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }14/N41/APN41.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }14/N41/FAN41.pdf`,
                    },
                    ],
                },
        // Licitación N40
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N40-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 28 de septiembre al 5 de octubre de 2020.',
                    'descripcionProcedimiento' : 'Construcción de carpeta asfáltica en la carretera estatal acceso a Grutas de Tolantongo, del Km. 12+870 al Km. 14+900; ubicada en la localidad de San Cristóbal, Municipio de Cardonal, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }14/N40/N40.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }14/N40/JAN40.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }14/N40/APN40.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }14/N40/FAN40.pdf`,
                    },
                    ],
                },
        // Licitación N39
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N39-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 28 de septiembre al 5 de octubre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica Calle Encinal; ubicada en la localidad de Ahuehuetl, Municipio de Huautla, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }14/N39/N39.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }14/N39/JAN39.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }14/N39/APN39.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }14/N39/FAN39.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 013
            'numConvocatoria' : 'Convocatoria No. 013/2020.',
            'idConvocatoria' : 'Convocatoria13',
            'procedimientos' : [
        // Licitación N38
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N38-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 28 de septiembre al 2 de octubre de 2020.',
                    'descripcionProcedimiento' : 'Actualización de distribuidor vial en la zona del altiplano y vía rápida Portezuelos - Zimapán; de Cobertura Estatal.',
                    'urlAnexos' : `${ ligabase }13/N38/N38.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }13/N38/JAN38.pdf`,
                    },
                    {
                        'resultado' : 'Oficio de diferimiento',
                        'urlresultado' : `${ ligabase }13/N38/ODN38.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }13/N38/APN38.pdf`,
                    },
                    {
                        'resultado' : 'Acta circunstanciada',
                        'urlresultado' : `${ ligabase }13/N38/ACN38.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }13/N38/FAN38.pdf`,
                    },
                    ],
                },
        // Licitación N37
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N37-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 28 de septiembre al 2 de octubre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica en Avenida Juárez salida a Ocotepec; ubicada en la localidad y Municipio de Apan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }13/N37/N37.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }13/N37/JAN37.pdf`,
                    },
                    {
                        'resultado' : 'Oficio de diferimiento',
                        'urlresultado' : `${ ligabase }13/N37/ODN37.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }13/N37/APN37.pdf`,
                    },
                    {
                        'resultado' : 'Acta circunstanciada',
                        'urlresultado' : `${ ligabase }13/N37/ACN37.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }13/N37/FAN37.pdf`,
                    },
                    ],
                },
        // Licitación N36
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N36-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 28 de septiembre al 2 de octubre de 2020.',
                    'descripcionProcedimiento' : 'Pavimentación Asfáltica del Camino Tepehuacán - Teyahuala; ubicada en la localidad de Chilijapa, Municipio de Tepehuacan de Guerrero, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }13/N36/N36.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }13/N36/JAN36.pdf`,
                    },
                    {
                        'resultado' : 'Oficio de diferimiento',
                        'urlresultado' : `${ ligabase }13/N36/ODN36.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }13/N36/APN36.pdf`,
                    },
                    {
                        'resultado' : 'Acta circunstanciada',
                        'urlresultado' : `${ ligabase }13/N36/ACN36.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }13/N36/FAN36.pdf`,
                    },
                    ],
                },
        // Licitación N35
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N35-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 28 de septiembre al 2 de octubre de 2020.',
                    'descripcionProcedimiento' : 'Reconstrucción de diversos caminos rurales en la Región Huejutla; ubicada en varias localidades del Municipio de Huautla, Estado de Hidalgo. (Segundo procedimiento).',
                    'urlAnexos' : `${ ligabase }13/N35/N35.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }13/N35/JAN35.pdf`,
                    },
                    {
                        'resultado' : 'Oficio de diferimiento',
                        'urlresultado' : `${ ligabase }13/N35/ODN35.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }13/N35/APN35.pdf`,
                    },
                    {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligabase }13/N35/AMDAPN35.pdf`,
                    },
                    {
                        'resultado' : 'Acta circunstanciada',
                        'urlresultado' : `${ ligabase }13/N35/ACN35.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }13/N35/FAN35.pdf`,
                    },
                    {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligabase }13/N35/AMDFAN35.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 012
            'numConvocatoria' : 'Convocatoria No. 012/2020.',
            'idConvocatoria' : 'Convocatoria12',
            'procedimientos' : [
        // Licitación N34
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N34-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 28 de septiembre al 2 de octubre de 2020.',
                    'descripcionProcedimiento' : 'Inversión en acciones de contraloría; de Cobertura Estatal.',
                    'urlAnexos' : `${ ligabase }12/N34/N34.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }12/N34/JAN34.pdf`,
                    },
                    {
                        'resultado' : 'Oficio de diferimiento',
                        'urlresultado' : `${ ligabase }12/N34/ODN34.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }12/N34/APN34.pdf`,
                    },
                    {
                        'resultado' : 'Acta circunstanciada',
                        'urlresultado' : `${ ligabase }12/N34/ACN34.pdf`,
                    },
                    {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligabase }12/N34/AMDAPN34.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }12/N34/FAN34.pdf`,
                    },
                    ],
                },
        // Licitación N33
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N33-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 28 de septiembre al 2 de octubre de 2020.',
                    'descripcionProcedimiento' : 'Reconstrucción de carreteras estatales Región Apan; ubicada en varias localidades del Municipio de Apan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }12/N33/N33.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }12/N33/JAN33.pdf`,
                    },
                    {
                        'resultado' : 'Oficio de diferimiento',
                        'urlresultado' : `${ ligabase }12/N33/ODN33.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }12/N33/APN33.pdf`,
                    },
                    {
                        'resultado' : 'Acta circunstanciada',
                        'urlresultado' : `${ ligabase }12/N33/ACN33.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }12/N33/FAN33.pdf`,
                    },
                    ],
                },
        // Licitación N32
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N32-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 28 de septiembre al 2 de octubre de 2020.',
                    'descripcionProcedimiento' : 'Reconstrucción de diversos caminos rurales en los municipios de San Bartolo Tutotepec y Tenango de Doria; de Cobertura Estatal.',
                    'urlAnexos' : `${ ligabase }12/N32/N32.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }12/N32/JAN32.pdf`,
                    },
                    {
                        'resultado' : 'Oficio de diferimiento',
                        'urlresultado' : `${ ligabase }12/N32/ODN32.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }12/N32/APN32.pdf`,
                    },
                    {
                        'resultado' : 'Acta circunstanciada',
                        'urlresultado' : `${ ligabase }12/N32/ACN32.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }12/N32/FAN32.pdf`,
                    },
                    ],
                },
        // Licitación N31
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N31-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 28 de septiembre al 2 de octubre de 2020.',
                    'descripcionProcedimiento' : 'Reconstrucción de camino rural Trancas-Nicolás Flores; ubicada en la localidad y Municipio de Nicolás Flores, Estado de Hidalgo. (Segundo procedimiento).',
                    'urlAnexos' : `${ ligabase }12/N31/N31.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }12/N31/JAN31.pdf`,
                    },
                    {
                        'resultado' : 'Oficio de diferimiento',
                        'urlresultado' : `${ ligabase }12/N31/ODN31.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }12/N31/APN31.pdf`,
                    },
                    {
                        'resultado' : 'Acta circunstanciada',
                        'urlresultado' : `${ ligabase }12/N31/ACN31.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }12/N31/FAN31.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 010
            'numConvocatoria' : 'Convocatoria No. 010/2020.',
            'idConvocatoria' : 'Convocatoria10',
            'procedimientos' : [
        // Licitación N26
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N26-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 31 de agosto al 4 de septiembre de 2020.',
                    'descripcionProcedimiento' : 'Reconstrucciones de diversos caminos rurales en la Región Molango; de Cobertura Estatal.',
                    'urlAnexos' : `${ ligabase }10/N26/N26.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }10/N26/JAN26.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }10/N26/APN26.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }10/N26/FAN26.pdf`,
                    },
                    ],
                },
        // Licitación N25
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N25-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 31 de agosto al 4 de septiembre de 2020.',
                    'descripcionProcedimiento' : 'Rehabilitación de carreteras estatales, tramos diversos de la Región Huejutla; de Cobertura Estatal.',
                    'urlAnexos' : `${ ligabase }10/N25/N25.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }10/N25/JAN25.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }10/N25/APN25.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }10/N25/FAN25.pdf`,
                    },
                    ],
                },
        // Licitación N24
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N24-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 31 de agosto al 4 de septiembre de 2020.',
                    'descripcionProcedimiento' : 'Reconstrucción de camino rural Trancas-Nicolás Flores; ubicada en la localidad y Municipio de Nicolás Flores, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }10/N24/N24.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }10/N24/JAN24.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }10/N24/APN24.pdf`,
                    },
                    ],
                },
        // Licitación N23
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N23-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 31 de agosto al 4 de septiembre de 2020.',
                    'descripcionProcedimiento' : 'Rehabilitación de C.E. Tepeji del Río-La Cañada; ubicada en la localidad de Cañada de Madero Hidalgo, Municipio de Tepeji del Río de Ocampo, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }10/N23/N23.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }10/N23/JAN23.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }10/N23/APN23.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }10/N23/FAN23.pdf`,
                    },
                    ],
                },
        // Licitación N22
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N22-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 31 de agosto al 4 de septiembre de 2020.',
                    'descripcionProcedimiento' : 'Rehabilitación de carreteras estatales, tramos diversos de la Región Pachuca; de Cobertura Estatal.',
                    'urlAnexos' : `${ ligabase }10/N22/N22.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }10/N22/JAN22.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }10/N22/APN22.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }10/N22/FAN22.pdf`,
                    },
                    ],
                },
        // Licitación N21
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N21-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 31 de agosto al 4 de septiembre de 2020.',
                    'descripcionProcedimiento' : 'Reconstrucciones de diversos caminos rurales en la Región Otomí Tepehua en los municipios de Huehuetla y Tenango de Doria; de Cobertura Estatal.',
                    'urlAnexos' : `${ ligabase }10/N21/N21.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }10/N21/JAN21.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }10/N21/APN21.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }10/N21/FAN21.pdf`,
                    },
                    ],
                },
        // Licitación N20
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N20-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 31 de agosto al 4 de septiembre de 2020.',
                    'descripcionProcedimiento' : 'Reconstrucción de diversos caminos rurales en la Región Huejutla; ubicada en varias localidades del Municipio de Huejutla de Reyes, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }10/N20/N20.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }10/N20/JAN20.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }10/N20/APN20.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }10/N20/FAN20.pdf`,
                    },
                    ],
                },
        // Licitación N19
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N19-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 31 de agosto al 4 de septiembre de 2020.',
                    'descripcionProcedimiento' : 'Reconstrucción de diversos caminos rurales en la Región Otomí Tepehua en el municipio de San Bartolo Tutotepec; ubicada en varias localidades del Municipio de San Bartolo Tutotepec, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }10/N19/N19.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }10/N19/JAN19.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }10/N19/APN19.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }10/N19/FAN19.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 009
            'numConvocatoria' : 'Convocatoria No. 009/2020.',
            'idConvocatoria' : 'Convocatoria9',
            'procedimientos' : [
        // Licitación N18
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N18-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 17 al 24 de agosto de 2020.',
                    'descripcionProcedimiento' : 'Estudio y proyecto para la construcción de distribuidor vial en el E.C.F. Pachuca - Huejutla - E.C.F. Álamo - Tamazunchale (Tres Huastecas), ubicado en la localidad y Municipio de Huejutla de Reyes, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }9/N18/N18.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }9/N18/JAN18.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }9/N18/APN18.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }9/N18/FAN18.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 008
            'numConvocatoria' : 'Convocatoria No. 008/2020.',
            'idConvocatoria' : 'Convocatoria8',
            'procedimientos' : [
        // Licitación N17
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N17-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 10 al 14 de agosto de 2020.',
                    'descripcionProcedimiento' : 'Elaboración de estudios y proyectos de infraestructura vial estratégica para la zona centro del estado, región conurbada de Pachuca; ubicada en varias localidades del Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }8/N17/N17.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }8/N17/JAN17.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }8/N17/APN17.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }8/N17/FAN17.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 007
            'numConvocatoria' : 'Convocatoria No. 007/2020.',
            'idConvocatoria' : 'Convocatoria7',
            'procedimientos' : [
        // Licitación N16
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N16-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 27 al 31 de julio de 2020.',
                    'descripcionProcedimiento' : 'Agencia de ministerios públicos, ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }7/N16/N16.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }7/N16/JAN16.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }7/N16/APN16.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }7/N16/FAN16.pdf`,
                    },
                    ],
                },
        // Licitación N15
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N15-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 27 al 31 de julio de 2020.',
                    'descripcionProcedimiento' : 'Centro de identificación humana para resguardo temporal de Hidalgo; de Cobertura Estatal.',
                    'urlAnexos' : `${ ligabase }7/N15/N15.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }7/N15/JAN15.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }7/N15/APN15.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }7/N15/FAN15.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 006
            'numConvocatoria' : 'Convocatoria No. 006/2020.',
            'idConvocatoria' : 'Convocatoria6',
            'procedimientos' : [
        // Licitación N14
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N14-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 20 al 24 de julio de 2020.',
                    'descripcionProcedimiento' : 'Rehabilitación de carreteras estatales, tramos diversos de la región Actopan; de Cobertura Estatal.',
                    'urlAnexos' : `${ ligabase }6/N14/N14.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }6/N14/JAN14.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }6/N14/APN14.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }6/N14/FAN14.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 005
            'numConvocatoria' : 'Convocatoria No. 005/2020.',
            'idConvocatoria' : 'Convocatoria5',
            'procedimientos' : [
        // Licitación N13
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N13-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 15 al 19 de junio de 2020.',
                    'descripcionProcedimiento' : 'Proyecto ejecutivo de troncal, pavimento, obras de drenaje, muros de contención, señalamiento, retornos, paraderos y rampas de emergencia y anteproyecto de entronques, de la vía en el tramo del Km. 50+400 al Km. 60+000; ubicado en varias localidades del Municipio de Atotonilco El Grande, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }5/N13/N13.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }5/N13/JAN13.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }5/N13/APN13.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }5/N13/FAN13.pdf`,
                    },
                    ],
                },
        // Licitación N12
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N12-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 15 al 19 de junio de 2020.',
                    'descripcionProcedimiento' : 'Proyecto ejecutivo de troncal, pavimento, obras de drenaje, muros de contención, señalamiento, retornos, paraderos y rampas de emergencia y anteproyecto de entronques, de la vía El Banco-Zacualtipán; ubicado en varias localidades del Municipio de Zacualtipán de Ángeles, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }5/N12/N12.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }5/N12/JAN12.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }5/N12/APN12.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }5/N12/FAN12.pdf`,
                    },
                    ],
                },
        // Licitación N11
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N11-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 15 al 19 de junio de 2020.',
                    'descripcionProcedimiento' : 'Modificación de la manifestación de impacto ambiental y actualización de programas para la construcción del camino Pachuca-Huejutla, tramo: Mineral del Monte-entronque Huasca; ubicado en la localidad y Municipio de Mineral del Monte, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }5/N11/N11.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }5/N11/JAN11.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }5/N11/APN11.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }5/N11/FAN11.pdf`,
                    },
                    ],
                },
        // Licitación N10
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N10-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 15 al 19 de junio de 2020.',
                    'descripcionProcedimiento' : 'Estudio de la manifestación de impacto ambiental modalidad regional para la modernización del camino Pachuca-Huejutla, tramo del Km. 50+400 al 60+000 (continuación de la vía raída en Cerro Colorado al Km. 60+000 aprox); ubicado en varias localidades del Municipio de Atotonilco El Grande, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }5/N10/N10.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }5/N10/JAN10.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }5/N10/APN10.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }5/N10/FAN10.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 004
            'numConvocatoria' : 'Convocatoria No. 004/2020.',
            'idConvocatoria' : 'Convocatoria4',
            'procedimientos' : [
        // Licitación N9
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N9-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 8 al 12 de junio de 2020.',
                    'descripcionProcedimiento' : 'Terminación de las instalaciones del Polideportivo PLATAH; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }4/N9/N9.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }4/N9/JAN9.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }4/N9/APN9.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }4/N9/FAN9.pdf`,
                    },
                    ],
                },
        // Licitación N8
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N8-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 8 al 12 de junio de 2020.',
                    'descripcionProcedimiento' : 'Remodelación de oficinas de la Dirección General de Contabilidad Gubernamental; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }4/N8/N8.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }4/N8/JAN8.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }4/N8/APN8.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }4/N8/FAN8.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 003
            'numConvocatoria' : 'Convocatoria No. 003/2020.',
            'idConvocatoria' : 'Convocatoria3',
            'procedimientos' : [
        // Licitación N7
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N7-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 11 al 15 de mayo de 2020.',
                    'descripcionProcedimiento' : 'Elaboración de los estudios y proyectos de infraestructura vial estratégica para la zona centro del estado, región Tula, Tulancingo y Valle del Mezquital; de Cobertura Estatal.',
                    'urlAnexos' : `${ ligabase }3/N7/N7.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }3/N7/JAN7.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }3/N7/APN7.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }3/N7/FAN7.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 002
            'numConvocatoria' : 'Convocatoria No. 002/2020.',
            'idConvocatoria' : 'Convocatoria2',
            'procedimientos' : [
        // Licitación N6
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N6-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 4 al 8 de mayo de 2020.',
                    'descripcionProcedimiento' : 'Rehabilitación de carreteras estatales, tramos diversos de las regiones Pachuca y Tizayuca; de Cobertura Estatal.',
                    'urlAnexos' : `${ ligabase }2/N6/N6.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }2/N6/JAN6.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }2/N6/APN6.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }2/N6/FAN6.pdf`,
                    },
                    ],
                },
        // Licitación N5
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N5-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 4 al 8 de mayo de 2020.',
                    'descripcionProcedimiento' : 'Rehabilitación de carreteras estatales, tramos diversos de las regiones Huejutla y Tepeji del Río; de Cobertura Estatal.',
                    'urlAnexos' : `${ ligabase }2/N5/N5.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }2/N5/JAN5.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }2/N5/APN5.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }2/N5/FAN5.pdf`,
                    },
                    ],
                },
        // Licitación N4
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N4-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 4 al 8 de mayo de 2020.',
                    'descripcionProcedimiento' : 'Rehabilitación de carreteras estatales, tramos diversos de las regiones Huichapan, Ixquimilpan y Metztitlán; de Cobertura Estatal.',
                    'urlAnexos' : `${ ligabase }2/N4/N4.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }2/N4/JAN4.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }2/N4/APN4.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }2/N4/FAN4.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 001
            'numConvocatoria' : 'Convocatoria No. 001/2020.',
            'idConvocatoria' : 'Convocatoria1',
            'procedimientos' : [
        // Licitación N3
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N3-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 9 al 23 de marzo de 2020.',
                    'descripcionProcedimiento' : 'Estudio de demanda y análisis de factibilidad económica para la modernización de la carretera Pachuca - Huejutla, tramo Cerro Colorado; ubicado en la localidad de Zacualtipán, Municipio de Zacualtipán de Ángeles, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }1/N3/N3.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }1/N3/JAN3.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }1/N3/APN3.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }1/N3/FAN3.pdf`,
                    },
                    ],
                },
        // Licitación N2
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N2-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 9 al 23 de marzo de 2020.',
                    'descripcionProcedimiento' : 'Estudio de la manifestación de impacto ambiental modalidad regional para la modernización del camino Pachuca - Huejutla, tramo: El Banco - Zacualtipán; ubicado en la localidad de Zacualtipán, Municipio de Zacualtipán de Ángeles, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }1/N2/N2.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }1/N2/JAN2.pdf`,
                    },
                    {
                        'resultado' : 'Anexo midificatorio',
                        'urlresultado' : `${ ligabase }1/N2/AMDJAN2.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }1/N2/APN2.pdf`,
                    },
                    {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligabase }1/N2/AMDAPN2.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }1/N2/FAN2.pdf`,
                    },
                    ],
                },
        // Licitación N1
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N1-2020.',
                    'vigencia' : 'Vigencia de venta de bases: del 9 al 23 de marzo de 2020.',
                    'descripcionProcedimiento' : 'Estudio técnico justificativo de cambio de uso de suelo para la construcción del camino Pachuca - Huejutla, tramo: Mineral del Monte - entronque Huasca; ubicado en la localidad y Municipio de Mineral del Monte, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }1/N1/N1.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }1/N1/JAN1.pdf`,
                    },
                    {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligabase }1/N1/AMDJAN1.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }1/N1/APN1.pdf`,
                    },
                    {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligabase }1/N1/AMDAPN1.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }1/N1/FAN1.pdf`,
                    },
                    ],
                },
            ],
    },
]